// This file is auto-generated by @hey-api/openapi-ts

export const AcceptInviteOutcome = {
  OK: "Ok",
  USER_NOT_FOUND: "UserNotFound",
  USER_ALREADY_HAS_SSN: "UserAlreadyHasSsn",
} as const;

export type AcceptInviteOutcome =
  typeof AcceptInviteOutcome[keyof typeof AcceptInviteOutcome];

export type Access = {
  level: AccessLevel;
  subject: AccessSubject;
};

export type AccessCode = {
  created_at: DateTime;
  data: AccessCodeData;
  id: string;
  series_id: string;
  updated_at: DateTime;
  usage_count: number;
};

export type AccessCodeData = {
  code: AccessCodeString;
  max_usage_count: number;
};

export type AccessCodeIds = {
  /**
   * AccessCode id
   */
  ids: Array<string>;
};

export type AccessCodeSeries = {
  composite_series_id?: string | null;
  connected_series: Array<AccessCodeSeriesRef>;
  connected_sites: Array<SiteRef>;
  created_at: DateTime;
  data: AccessCodeSeriesData;
  id: string;
  is_composite: boolean;
  tag_count: number;
  updated_at: DateTime;
};

export type AccessCodeSeriesData = {
  description?: string | null;
  name: string;
};

export type AccessCodeSeriesId = {
  /**
   * AccessCodeSeries id
   */
  id: string;
};

export type AccessCodeSeriesIds = {
  /**
   * AccessCodeSeries ids
   */
  ids: Array<string>;
};

export type AccessCodeSeriesRef = {
  description?: string | null;
  id: string;
  name: string;
};

export type AccessCodeString = string;

export type AccessCodesBulkCreate = {
  data: Array<AccessCodeData>;
  series_id: string;
};

export type AccessCodesBulkUpdate = {
  ids: Array<string>;
  max_usage_count: number;
};

export type AccessCodesSearch = {
  codePrefix?: AccessCodeString | null;
  ids?: Array<string> | null;
  page?: number | null;
  pageSize?: number | null;
  seriesIds?: Array<string> | null;
  siteIds?: Array<string> | null;
};

export const AccessLevel = {
  ADMIN: "Admin",
  READER: "Reader",
} as const;

export type AccessLevel = typeof AccessLevel[keyof typeof AccessLevel];

export type AccessSubject = "Global" | {
  Client: {
    id: string;
  };
} | {
  Site: {
    id: string;
  };
};

export type Agreement = {
  approvedAt?: DateTime | null;
  createdAt: DateTime;
  data: AgreementData;
  debtor: DebtorRef;
  /**
   * Articles derived from the associated spots
   */
  derivedArticles: Array<AgreementArticle>;
  events: Array<AgreementEvent>;
  id: string;
  number: number;
  offerDeclinedAt?: DateTime | null;
  offerExpiresAt?: DateTime | null;
  offeredAt?: DateTime | null;
  pdf?: AgreementPdfInfo | null;
  permit?: Permit | null;
  spots: Array<AgreementSpot>;
  state: AgreementState;
  supersededBy?: string | null;
  supersedes?: string | null;
  updatedAt?: DateTime | null;
  wasPreApproved?: boolean | null;
};

/**
 * Helper struct to make it easier for Frontend
 */
export type AgreementAccess = {
  accessLevel: DebtorAccessLevel;
  agreement: Agreement;
};

export type AgreementArticle = {
  endDate?: _Date | null;
  name: string;
  price: Price;
  productId: string;
  quantity: number;
  startDate: _Date;
};

export type AgreementConflicts = {
  agreements: Array<BlockingAgreement>;
  spots: Array<BlockedSpot>;
};

export type AgreementData = {
  debtorId: string;
  endDate?: _Date | null;
  invoiceFrom: _Date;
  invoicingOffset?: Months | null;
  isResidental: boolean;
  noticePeriod: Interval;
  offerNoticePeriod: Interval;
  period?: Interval | null;
  priceIndexing?: PriceIndexing | null;
  siteId: string;
  startDate?: _Date | null;
  supersedesId?: string | null;
};

/**
 * A tag attached to an agreement spot. Contains a snapshot of how the tag looked when agreement was approved.
 */
export type AgreementEvent = {
  createdAt: DateTime;
  id: string;
  kind: AgreementEventKind;
  userRef: UserRef;
};

export const AgreementEventKind = {
  CREATED: "Created",
  SENT: "Sent",
  REJECTED: "Rejected",
  RESET_TO_DRAFT: "ResetToDraft",
  APPROVED: "Approved",
  ENDED: "Ended",
  REPLACED: "Replaced",
} as const;

export type AgreementEventKind =
  typeof AgreementEventKind[keyof typeof AgreementEventKind];

export type AgreementId = {
  /**
   * Agreement id
   */
  id: string;
};

export type AgreementId2 = {
  agreement_id: string;
};

export type AgreementIds = {
  /**
   * Agreement id
   */
  ids: Array<string>;
};

/**
 * A reply to an offerred agreement.
 */
export const AgreementOfferReply = {
  ACCEPT: "accept",
  REJECT: "reject",
} as const;

/**
 * A reply to an offerred agreement.
 */
export type AgreementOfferReply =
  typeof AgreementOfferReply[keyof typeof AgreementOfferReply];

/**
 * The Pdf generated for an Agreement
 */
export type AgreementPdfInfo = {
  fileSize: number;
  filename: string;
  generatedAt: DateTime;
};

export type AgreementRef = {
  approvedAt?: DateTime | null;
  endDate?: _Date | null;
  id: string;
  number: number;
  offerDeclinedAt?: DateTime | null;
  offerExpiresAt?: DateTime | null;
  offerNoticePeriod: Interval;
  offeredAt?: DateTime | null;
  startDate?: _Date | null;
  state: AgreementState;
};

export type AgreementSettings = {
  createdAt: DateTime;
  data: AgreementSettingsData;
  updatedAt?: DateTime | null;
};

export type AgreementSettingsData = {
  agreementPeriod?: Months | null;
  automaticAttest: boolean;
  noticePeriod: Months;
  offerNoticePeriod: Days;
  paymentTerms: PaymentTerms;
  startInvoicingAt?: _Date | null;
  stopInvoicingAt?: _Date | null;
};

/**
 * A spot when attached to an Agreement. Contains a snapshot of how the spot looked when agreement was approved.
 */
export type AgreementSpot = {
  createdAt: DateTime;
  id: string;
  name: string;
  numericName: number;
  spotId?: string | null;
  tags: Array<AgreementTag>;
  updatedAt?: DateTime | null;
  usedAccessCode?: AccessCodeString | null;
};

export type AgreementState = {
  stage: "draft";
} | {
  expiresAfter: DateTime;
  offeredAt: DateTime;
  stage: "offered";
} | {
  expiredAt: DateTime;
  offeredAt: DateTime;
  stage: "offerExpired";
} | {
  declinedAt: DateTime;
  stage: "offerDeclined";
} | {
  stage: "approved";
} | {
  stage: "active";
} | {
  stage: "ending";
} | {
  stage: "ended";
};

export type AgreementStats = {
  activeCount: number;
  activeValue: Amount;
  approvedCount: number;
  approvedValue: Amount;
  draftCount: number;
  draftValue: Amount;
  endedCount: number;
  endedValue: Amount;
  endingCount: number;
  endingValue: Amount;
  offerDeclinedCount: number;
  offerDeclinedValue: Amount;
  offerExpiredCount: number;
  offerExpiredValue: Amount;
  offeredCount: number;
  offeredValue: Amount;
};

/**
 * A tag attached to an agreement spot. Contains a snapshot of how the tag looked when agreement was approved.
 */
export type AgreementTag = {
  color?: number | null;
  createdAt: DateTime;
  description?: string | null;
  id: string;
  internalDescription?: string | null;
  isInternal: boolean;
  name: string;
  price?: TagPricing | null;
  tagId?: string | null;
  updatedAt?: DateTime | null;
};

export type AgreementUpdate = {
  additionalTerms?: string | null;
  applicantId?: string | null;
  data: AgreementData;
  spotIds: Array<string>;
  tagOverrides?: Array<OverrideAgreementTag> | null;
};

export type AgreementUpdateResult = {
  agreement?: Agreement | null;
  conflicts?: AgreementConflicts | null;
};

export type AgreementsWithEndDate = {
  /**
   * End date
   */
  endDate: _Date;
  /**
   * Agreement id
   */
  ids: Array<string>;
};

export type Amount = number;

export type AppSites = {
  sites: Array<SiteAccess>;
};

export type ApplicantId = {
  /**
   * Applicant id
   */
  id: string;
};

export type ApplicantIds = {
  /**
   * Applicant ids
   */
  ids: Array<string>;
};

export type Area = {
  createdAt: DateTime;
  data: AreaData;
  id: string;
  spots: Array<SpotRef>;
  updatedAt?: DateTime | null;
};

export type AreaData = {
  description?: string | null;
  name: string;
};

export type AreaRef = {
  id: string;
  name: string;
};

export type ArticleOfPermitPayPreview = {
  name: string;
  period: Period;
  periodPrice: Price;
  quantity: number;
  unitPrice: Price;
};

export const AuthMethod = {
  QR: "qr",
  START_TOKEN: "startToken",
} as const;

export type AuthMethod = typeof AuthMethod[keyof typeof AuthMethod];

export type AuthToken = {
  authToken: string;
};

export type AutogiroPaymentSettings = {
  accountNr: string;
  bankName?: string | null;
  clearingNr: ClearingNumber;
  payerNr?: string | null;
};

export const Availability = {
  FULL: "full",
  ALMOST_FULL: "almostFull",
  LOADS_OF_FREE_SPACE: "loadsOfFreeSpace",
} as const;

export type Availability = typeof Availability[keyof typeof Availability];

/**
 * Base64
 */
export type Base64 = string;

export type BillectaCreditor = {
  createdAt: DateTime;
  data: BillectaCreditorData;
  remoteId: string;
  remoteName?: string | null;
  updatedAt?: DateTime | null;
};

export type BillectaCreditorData = {
  adminFee?: number | null;
  adminFeeVat?: number | null;
  incomingBankgiro?: string | null;
  kundfordringar?: number | null;
  outgoingBankgiro?: string | null;
  payments?: number | null;
  revenue?: number | null;
  writeOffs?: number | null;
};

export type BillectaCreditorRef = {
  isLocal: boolean;
  remoteId: string;
  remoteName?: string | null;
};

export type BillectaSyncTarget = {
  id: string;
  target: "debtor";
} | {
  productId: string;
  siteId: string;
  target: "productInSite";
};

export type BlockedSpot = {
  blockedFrom?: _Date | null;
  blockedUntil?: _Date | null;
  spot: SpotRef;
};

export type BlockingAgreement = {
  agreement: AgreementRef;
  spots: Array<SpotRef>;
};

export type CalculateSiteStats = {
  from?: _Date | null;
  site_ids?: Array<string> | null;
  to?: _Date | null;
};

export type CalculationOutcome = {
  added_count: number;
  earliest_entry_date?: _Date | null;
  latest_entry_date?: _Date | null;
  removed_count: number;
};

export const CardSetupStatus = {
  CANCELED: "Canceled",
  PROCESSING: "Processing",
  REQUIRES_ACTION: "RequiresAction",
  REQUIRES_CONFIRMATION: "RequiresConfirmation",
  REQUIRES_PAYMENT_METHOD: "RequiresPaymentMethod",
  SUCCEEDED: "Succeeded",
} as const;

export type CardSetupStatus =
  typeof CardSetupStatus[keyof typeof CardSetupStatus];

export type Circle = {
  lat: number;
  lng: number;
  rad: number;
};

export type ClearSiteStats = {
  from: _Date;
  site_ids: Array<string>;
  to: _Date;
};

export type ClearingNumber = string;

export type ClientRow = {
  created_at: DateTime;
  id: string;
  name: string;
  site_count: number;
  spot_count: number;
  updated_at?: DateTime | null;
};

export type Color = string;

export type CommissionData = {
  fixedPerClosed?: Amount | null;
  fixedPerSent?: Amount | null;
  percentOnClosed?: Percent | null;
  percentOnSent?: Percent | null;
  productId: string;
};

export type ConnectAccessCodeSeriesOutcome = {
  kind: "ok";
} | {
  kind: "selfIsConnected";
} | {
  kind: "cannotConnectToSelf";
} | {
  data: {
    duplicate_codes: Array<AccessCodeString>;
  };
  kind: "wouldCauseDuplicates";
} | {
  data: {
    composite_series: Array<AccessCodeSeriesRef>;
  };
  kind: "cannotConnectComposites";
};

export type Coordinates = {
  lat: number;
  lng: number;
};

export type CounterState = {
  count: number;
};

export type CreateAccessCodeSeries = {
  /**
   * Series data
   */
  data: AccessCodeSeriesData;
  /**
   * Site_ids to connect to the new series.
   */
  site_ids: Array<string>;
};

export type CreateDebtorUser = {
  accessLevel: DebtorAccessLevel;
  email: EmailAddress;
};

export type CreatePermitGrant = {
  forSelf: {
    license_plate: LicensePlate;
  };
} | {
  inviteUser: {
    email: EmailAddress;
  };
} | {
  inviteAdmin: {
    email: EmailAddress;
  };
};

export type CreatePermitOutcome = {
  details: {
    agreement: Agreement;
  };
  result: "ok";
} | {
  details: {
    available_capacity: number;
  };
  result: "wouldExceedSpotCapacity";
} | {
  result: "invalidAccessCode";
};

export type CreateSpotGroup = {
  capacity?: number | null;
  data: SpotData;
  notes?: string | null;
  siteId: string;
  sizeOverride?: number | null;
  spotIds: Array<string>;
};

export type CreateSpotShare = {
  agreementSpotId?: string | null;
  email: EmailAddress;
  spotId: string;
  validFrom?: DateTime;
  validUntil?: DateTime | null;
};

export type CreatedSpotGroup = {
  siteId: string;
  spot: Spot;
};

export type CreditorId = {
  /**
   * Creditor id
   */
  id: string;
};

export type CsvError = {
  details: Array<LineMessage>;
  kind: "lineErrors";
} | {
  details: Array<string>;
  kind: "other";
};

export type CsvImportOutcome = {
  details: CsvImportSuccess;
  kind: "success";
} | {
  details: CsvError;
  kind: "errors";
};

export type CsvImportSuccess = {
  createdAgreements: Array<string>;
  createdDebtors: Array<string>;
  importId: number;
};

/**
 * A date in the format YYYY-MM-DD
 */
export type _Date = string;

export type DateTime = string;

export type Days = number;

export type Debtor = {
  address?: string | null;
  addressCo?: string | null;
  apartmentNr?: string | null;
  city?: string | null;
  contactEmail?: EmailAddress | null;
  createdAt: DateTime;
  deliveryMethod?: DebtorDeliveryMethod | null;
  id: string;
  language?: DebtorLanguage | null;
  name: string;
  paymentMethod: DebtorPaymentMethod;
  phone?: string | null;
  protectedIdentity: boolean;
  protectedMailDelivery: boolean;
  sid: SwedishId;
  updatedAt?: DateTime | null;
  yourReference?: string | null;
  zip?: string | null;
};

export type DebtorAccess = {
  accessLevel: DebtorAccessLevel;
  debtor: Debtor;
};

export const DebtorAccessLevel = {
  USER: "User",
  ADMIN: "Admin",
  OWNER: "Owner",
} as const;

export type DebtorAccessLevel =
  typeof DebtorAccessLevel[keyof typeof DebtorAccessLevel];

export type DebtorAndCardId = {
  /**
   * Card id
   */
  cardId: string;
  /**
   * Debtor id
   */
  debtorId: string;
};

export type DebtorAndCardSetupId = {
  /**
   * Debtor id
   */
  debtorId: string;
  /**
   * Setup id
   */
  setupId: string;
};

export type DebtorAndInvoiceId = {
  /**
   * Debtor id
   */
  debtorId: string;
  invoiceId: number;
};

export type DebtorAndPaymentId = {
  /**
   * Debtor id
   */
  debtor_id: string;
  /**
   * Payment id
   */
  payment_id: string;
};

export type DebtorBatchDeleteResult = {
  deletedAgreementIds: Array<string>;
  results: {
    [key: string]: DebtorDeleteResult;
  };
};

export type DebtorData = {
  address?: string | null;
  addressCo?: string | null;
  apartmentNr?: string | null;
  city?: string | null;
  contactEmail?: EmailAddress | null;
  language?: DebtorLanguage | null;
  name: string;
  phone?: string | null;
  protectedIdentity: boolean;
  protectedMailDelivery: boolean;
  sid: SwedishId;
  yourReference?: string | null;
  zip?: string | null;
};

export const DebtorDeleteResult = {
  DELETED: "deleted",
  BLOCKED_BY_AGREEMENTS: "blockedByAgreements",
} as const;

export type DebtorDeleteResult =
  typeof DebtorDeleteResult[keyof typeof DebtorDeleteResult];

export type DebtorDeliveryMethod = "none" | "kivra" | {
  mail: MailDelivery;
} | {
  email: EmailDelivery;
} | {
  sms: SmsDelivery;
} | {
  eInvoicePerson: EInvoiceBank;
} | {
  eInvoiceCompany: EInvoiceCompany;
};

export type DebtorId = {
  /**
   * Debtor id
   */
  id: string;
};

export type DebtorId2 = {
  /**
   * Debtor id
   */
  debtorId: string;
};

export type DebtorIds = {
  /**
   * List of debtor Ids
   */
  debtorIds: Array<string>;
};

/**
 * A model used to summarize data for a Debtor.
 */
export type DebtorInvoiceSub = {
  amount: Amount;
  closedAt?: DateTime | null;
  deliveryMethod: DeliveryMethod;
  dueDate: _Date;
  id: number;
  invoiceDate: _Date;
  invoiceNr: string;
  reminderSentAt?: DateTime | null;
  state: InvoiceState;
};

export const DebtorLanguage = {
  SWEDISH: "swedish",
  ENGLISH: "english",
  FINNISH: "finnish",
} as const;

export type DebtorLanguage = typeof DebtorLanguage[keyof typeof DebtorLanguage];

export type DebtorPaymentMethod = "invoice" | {
  autogiro: AutogiroPaymentSettings;
};

export type DebtorRef = {
  email?: EmailAddress | null;
  id: string;
  name: string;
  phone?: string | null;
  sid: SwedishId;
};

export type DebtorUser = {
  accessLevel: DebtorAccessLevel;
  grantedAt: DateTime;
  grantedBy?: UserRef | null;
  user: UserRef;
};

export type DebtorWithPaymentCards = {
  address?: string | null;
  addressCo?: string | null;
  apartmentNr?: string | null;
  cards: Array<PaymentCard>;
  city?: string | null;
  contactEmail?: EmailAddress | null;
  createdAt: DateTime;
  deliveryMethod?: DebtorDeliveryMethod | null;
  id: string;
  language?: DebtorLanguage | null;
  name: string;
  paymentMethod: DebtorPaymentMethod;
  phone?: string | null;
  protectedIdentity: boolean;
  protectedMailDelivery: boolean;
  sid: SwedishId;
  updatedAt?: DateTime | null;
  yourReference?: string | null;
  zip?: string | null;
};

export const DeliveryMethod = {
  NONE: "none",
  EMAIL: "email",
  MAIL: "mail",
  SMS: "sms",
  E_INVOICE_PERSON: "eInvoicePerson",
  E_INVOICE_COMPANY: "eInvoiceCompany",
  KIVRA: "kivra",
  AVY: "avy",
} as const;

export type DeliveryMethod = typeof DeliveryMethod[keyof typeof DeliveryMethod];

export type Device = {
  action: DeviceAction;
  connection: DeviceConnection;
  createdAt: DateTime;
  description?: string | null;
  entranceId?: string | null;
  id: string;
  name: string;
  relay?: number | null;
  siteId: string;
  updatedAt?: DateTime | null;
};

export const DeviceAction = {
  TRIGGER: "trigger",
  OPEN: "open",
  CLOSE: "close",
} as const;

export type DeviceAction = typeof DeviceAction[keyof typeof DeviceAction];

export type DeviceConnection = {
  m46Remote: M46Remote;
} | {
  m46Bt: M46Bt;
};

export type DeviceData = {
  action: DeviceAction;
  connection: DeviceConnection;
  description?: string | null;
  entranceId?: string | null;
  name: string;
  relay?: number | null;
  siteId: string;
};

export type DeviceId = {
  /**
   * Device id
   */
  id: string;
};

export type DeviceIds = {
  /**
   * List of device ids
   */
  deviceIds: Array<string>;
};

export type DpLiteAccess = {
  activeAgreements: boolean;
  actuateDevices: boolean;
  checkSsn: boolean;
  fullAccess: boolean;
  listEntrances: boolean;
  subject: DpLiteAccessSubject;
  subjectName: string;
  supportInfo: boolean;
  vacantSpots: boolean;
};

export type DpLiteAccessSubject = {
  client: string;
} | {
  site: string;
};

export type DpLiteCreateUser = {
  comment?: string | null;
  password: string;
  username: string;
};

export type DpLiteCreateUserWithAccess = {
  access: Array<DpLiteSetAccess>;
  user: DpLiteCreateUser;
};

export type DpLiteSearch = {
  query?: string | null;
};

export type DpLiteSetAccess = {
  activeAgreements: boolean;
  actuateDevices: boolean;
  checkSsn: boolean;
  fullAccess: boolean;
  listEntrances: boolean;
  subject: DpLiteAccessSubject;
  supportInfo: boolean;
  vacantSpots: boolean;
};

export type DpLiteSetPassword = {
  password: string;
};

export type DpLiteUser = {
  comment?: string | null;
  id: string;
  lastSeenAt?: DateTime | null;
  username: string;
};

export type DpLiteUserId = {
  id: string;
};

export type DpLiteUserWithAccess = {
  access: Array<DpLiteAccess>;
  user: DpLiteUser;
};

export type EInvoiceBank =
  | "oeb"
  | "seb"
  | "shb"
  | "skb"
  | "fspa"
  | "nb"
  | "lfb"
  | "finn"
  | "ica"
  | "syd"
  | "dnb"
  | "sbf"
  | "aab"
  | "dbf"
  | "sebf"
  | "shbf"
  | "nbf"
  | "frx"
  | "marg";

export type EInvoiceCompany = {
  globalId?: string | null;
  intermediator: EInvoiceIntermediator;
};

export type EInvoiceIntermediator =
  | "itella"
  | "tietose"
  | "logica"
  | "proceedo"
  | "husera"
  | "basware"
  | "edb"
  | "stralfors1"
  | "liasionFi"
  | "export"
  | "essesess"
  | "handsess"
  | "dabasess"
  | "swedsess"
  | "ndeasess"
  | "inExchange"
  | "scancloud"
  | "pagero"
  | "crediflow"
  | "peppol"
  | "compello"
  | "logiq"
  | "apix"
  | "aksesspunkt"
  | "fininvoice";

export type EmailAddress = string;

export type EmailDelivery = {
  email: EmailAddress;
};

export type EmailRecipient = {
  deliveredAt?: DateTime | null;
  email: EmailAddress;
  state: EmailRecipientState;
};

export const EmailRecipientState = {
  FAILED: "failed",
  QUEUED: "queued",
  DELIVERED: "delivered",
} as const;

export type EmailRecipientState =
  typeof EmailRecipientState[keyof typeof EmailRecipientState];

export const EmailState = {
  FAILED: "failed",
  QUEUED: "queued",
  PARTIALLY_DELIVERED: "partiallyDelivered",
  DELIVERED: "delivered",
} as const;

export type EmailState = typeof EmailState[keyof typeof EmailState];

export type Entrance = {
  createdAt: DateTime;
  data: EntranceData;
  devices: Array<Device>;
  id: string;
  siteId: string;
  updatedAt?: DateTime | null;
};

export type EntranceData = {
  description?: string | null;
  imageUrl?: string | null;
  locLat?: number | null;
  locLng?: number | null;
  locRadius?: number | null;
  name: string;
};

export type EntranceId = {
  /**
   * Entrance id
   */
  id: string;
};

export type EntranceIds = {
  /**
   * Entrance ids
   */
  entrance_ids: Array<string>;
};

export type FinalizePaymentCardSetup = {
  cardName: string;
};

export type FinalizePaymentCardSetupWithAuthToken = {
  authToken: string;
  cardName: string;
};

export type GrantId = {
  grant_id: string;
};

export type GrantIds = {
  grantIds: Array<string>;
};

export type Id = {
  id: string;
};

export type ImportDefaults = {
  agreementPeriod?: Months | null;
  invoicingStart?: _Date | null;
  noticePeriod?: Months | null;
  offerNoticePeriod?: Days | null;
};

export type ImportId = {
  importId: number;
};

export type ImportP46Site = {
  facilityId: string;
};

export type IndexedDebtor = {
  debtor: Debtor;
  id: string;
  sites?: Array<SiteRef>;
};

export type Indexes = {
  indexes: Array<SearchIndex>;
};

export type Interval = {
  days: number;
  micros: number;
  months: number;
};

export type Invite = {
  invitedUserId: string;
};

export type Invoice = {
  attestedAt?: DateTime | null;
  debtorId: string;
  fee?: Price | null;
  id: string;
  number: string;
  period: Ym;
  records: Array<InvoiceRecord>;
  refundedAt?: DateTime | null;
};

export type InvoiceRecord = {
  description?: string | null;
  id: string;
  period: Period;
  productId: string;
  quantity: number;
  seq?: number | null;
  siteId: string;
  unit: InvoiceRecordUnit;
  unitPrice: Price;
};

export const InvoiceRecordUnit = {
  MONTH: "Month",
  EA: "Ea",
} as const;

export type InvoiceRecordUnit =
  typeof InvoiceRecordUnit[keyof typeof InvoiceRecordUnit];

export const InvoiceState = {
  SENT: "sent",
  REMINDER_SENT: "reminderSent",
  CLOSED: "closed",
} as const;

export type InvoiceState = typeof InvoiceState[keyof typeof InvoiceState];

export type LenderInfo = {
  address?: string | null;
  city?: string | null;
  name?: string | null;
  orgnr?: Organisationsnummer | null;
  updatedAt?: DateTime | null;
  zip?: string | null;
};

export type LenderInfoData = {
  address?: string | null;
  city?: string | null;
  name?: string | null;
  orgnr?: Organisationsnummer | null;
  zip?: string | null;
};

export type LicensePlate = string;

export type LineMessage = {
  line?: number | null;
  message: string;
};

export type LogMessage = {
  message: string;
};

export type LoginState = "inProgress" | "cancelled" | {
  failed: {
    error: string;
  };
} | {
  succeeded: {
    jwt: string;
    user: User;
  };
};

export type LoginStatus = {
  autoStartToken: string;
  id: string;
  messageCode: string;
  qrCode: string;
  state: LoginState;
};

export type M46Bt = {
  bluetoothId: string;
};

export type M46Remote = {
  remoteId: string;
};

export type MailDelivery = {
  address: string;
  city: string;
  co?: string | null;
  name: string;
  zip: string;
};

export type MasqueradeResult = {
  jwt: string;
  user: User;
};

export type MasqueradeTarget = {
  person: Personnummer;
} | {
  user: string;
};

export type Months = number;

/**
 * A Public variant of a site. Images and other public information should be added here once available.
 */
export type MyPagesQueueApplication = {
  agreementApproved: boolean;
  agreementId?: string | null;
  createdAt: DateTime;
  debtor?: DebtorRef | null;
  email?: EmailAddress | null;
  enqueuedAt: DateTime;
  id: string;
  notes?: string | null;
  preferredStartDate?: _Date | null;
  queueId: string;
  queueName: string;
  refresh?: QueueApplicantRefresh | null;
  updatedAt?: DateTime | null;
  volition: QueueApplicantVolition;
  wantsResidentalVatFree?: boolean | null;
};

/**
 * A Public variant of a site. Images and other public information should be added here once available.
 */
export type MyPagesSite = {
  id: string;
  name: string;
  rentalInfo?: RentalInfo | null;
};

/**
 * A Public variant of a Spot. Images and other public information should be added here once available.
 */
export type MyPagesSpot = {
  accessCodeRef?: AccessCodeSeriesRef | null;
  agreementPeriod?: Interval | null;
  area?: AreaRef | null;
  blockedFrom?: _Date | null;
  blockedUntil?: _Date | null;
  derivedPrice?: SpotPrice | null;
  id: string;
  kind: SpotKind;
  name: string;
  numericName: number;
  siteId: string;
  tagIds: Array<string>;
};

export type MyPagesStart = {
  agreements: Array<AgreementAccess>;
  applicants: Array<MyPagesQueueApplication>;
  debtors: Array<DebtorAccess>;
  sites: Array<MyPagesSite>;
  spotShares: Array<SpotShare>;
};

export type NewEntrance = {
  data: EntranceData;
  siteId: string;
};

export type NewQueueApplicant = {
  debtorId: string;
  preferredStartDate?: _Date | null;
  volition: QueueApplicantVolition;
  wantsResidentalVatFree?: boolean | null;
};

export type NumRemoved = {
  num_removed: number;
};

export type Organisationsnummer = string;

/**
 * Description of how an AgreementTag should be modified during the creation of an Agreement
 */
export type OverrideAgreementTag = {
  price: Amount;
  spotId: string;
  tagId: string;
};

export type P46Debtor = {
  careOf?: string | null;
  city?: string | null;
  createdAt: DateTime;
  email?: string | null;
  facilityId: string;
  id: string;
  name?: string | null;
  phone?: string | null;
  sid?: SwedishId | null;
  street?: string | null;
  updatedAt?: DateTime | null;
  url: string;
  zip?: string | null;
};

export type P46Site = {
  billectaCreditorId?: string | null;
  city?: string | null;
  code?: string | null;
  id: string;
  latitude?: number | null;
  longitude?: number | null;
  name: string;
  street?: string | null;
  url: string;
  zip?: string | null;
};

export type Paginate = {
  page: number;
  pageSize: number;
};

export type PaginatedForAccessCode = {
  items: Array<AccessCode>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForAccessCodeSeries = {
  items: Array<AccessCodeSeries>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForClientRow = {
  items: Array<ClientRow>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForEntrance = {
  items: Array<Entrance>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForMyPagesSpot = {
  items: Array<MyPagesSpot>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForPayment = {
  items: Array<Payment>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForPaymentWithDebtor = {
  items: Array<PaymentWithDebtor>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForPermitGrantInfo = {
  items: Array<PermitGrantInfo>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForPermitSession = {
  items: Array<PermitSession>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForProductRow = {
  items: Array<ProductRow>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForPublicSiteRow = {
  items: Array<PublicSiteRow>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForSentEmail = {
  items: Array<SentEmail>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForSiteRow = {
  items: Array<SiteRow>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PaginatedForSpotShare = {
  items: Array<SpotShare>;
  page: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
};

export type PayPermitOutcome = {
  details: {
    email_sent: boolean;
    permit: Permit;
    sessions: Array<PermitSession>;
  };
  kind: "succeeded";
} | {
  details: {
    access_code_id: string;
  };
  kind: "accessCodeAtCapacity";
} | {
  kind: "insufficientFunds";
} | {
  kind: "cardDeclined";
} | {
  kind: "unknownPaymentError";
};

export type Payment = {
  amount: Price;
  id: string;
  invoice: Invoice;
  performedAt: DateTime;
  refundedAt?: DateTime | null;
};

export type PaymentCard = {
  brand: string;
  expiry: Ym;
  hasExpired: boolean;
  id: string;
  isDefault: boolean;
  last4: string;
};

export type PaymentCardSetup = {
  id: string;
  publicKey: string;
  status: CardSetupStatus;
  stripeSecret: string;
};

export type PaymentStatus = {
  at: DateTime;
  type: "paid";
  until: _Date;
} | {
  at: DateTime;
  type: "paymentFailed";
};

export type PaymentTerms = "lastInMonth" | {
  day: number;
};

export type PaymentWithDebtor = {
  amount: Price;
  debtor: DebtorRef;
  id: string;
  invoice: Invoice;
  performedAt: DateTime;
  refundedAt?: DateTime | null;
};

/**
 * Percent. Accurate to 2 decimals
 */
export type Percent = number;

export type Period = {
  from: _Date;
  to: _Date;
};

export type Period2 = {
  period: Ym;
};

export type Permit = {
  autoRenewal: boolean;
  capacity: number;
  grants: Array<PermitGrant>;
  id: string;
  paymentStatus?: PaymentStatus | null;
  period: Interval;
};

export type PermitCreate = {
  accessCode?: AccessCodeString | null;
  capacity: number;
  debtorId: string;
  initialLicensePlates: Array<LicensePlate>;
  spotId: string;
  startDate: _Date;
};

export type PermitGrant = {
  activeSession?: PermitSession | null;
  data: PermitGrantData;
  id: string;
  permitId: string;
};

export type PermitGrantData = {
  accessLevel: DebtorAccessLevel;
  licensePlate?: LicensePlate | null;
  user: UserRef;
};

export type PermitGrantInfo = {
  agreement: AgreementRef;
  grant: PermitGrant;
  site: SiteRef;
};

export type PermitId = {
  permit_id: string;
};

export type PermitPayPreview = {
  articles: Array<ArticleOfPermitPayPreview>;
  permitId: string;
  recurring?: PermitPayPreviewRecurring | null;
};

export type PermitPayPreviewRecurring = {
  nextDebitAt: _Date;
  period: Interval;
  price: Price;
};

export type PermitSession = {
  endedAt?: DateTime | null;
  licensePlate: LicensePlate;
  startedAt: DateTime;
};

export type PermitSessionData = {
  licensePlate: LicensePlate;
};

export type Personnummer = string;

export type PostPaymentReceipt = {
  email?: EmailAddress | null;
};

export type Price = {
  sub: Amount;
  vat: Amount;
};

export type PriceIndexMethod = "baseIndex" | {
  monthly: {
    percent: number;
  };
} | {
  quarterly: {
    percent: number;
  };
} | {
  yearly: {
    percent: number;
  };
};

export type PriceIndexing = {
  from: _Date;
  method: PriceIndexMethod;
};

export type Product = {
  articleNumber?: string | null;
  createdAt: DateTime;
  deletedAt?: DateTime | null;
  id: string;
  kind: ProductKind;
  name: string;
  updatedAt?: DateTime | null;
};

export type ProductCommission = {
  data: CommissionData;
  deletedAt?: DateTime | null;
  kind: ProductCommissionKind;
  productName: string;
};

export const ProductCommissionKind = {
  NORMAL: "Normal",
  NOT_USED_ON_SITE: "NotUsedOnSite",
  P46: "P46",
} as const;

export type ProductCommissionKind =
  typeof ProductCommissionKind[keyof typeof ProductCommissionKind];

export type ProductData = {
  articleNumber?: string | null;
  kind: ProductKind;
  name: string;
};

export type ProductId = {
  /**
   * Product id
   */
  id: string;
};

export const ProductKind = {
  RESERVED: "Reserved",
  PERMIT: "Permit",
  OTHER: "Other",
} as const;

export type ProductKind = typeof ProductKind[keyof typeof ProductKind];

export type ProductRow = {
  associatedClientIds: Array<string>;
  associatedSiteIds: Array<string>;
  product: Product;
};

export type ProductSearch = {
  pagination?: Paginate;
  query?: string | null;
  siteIds?: Array<string> | null;
  sort?: SortForProductSort;
};

export const ProductSort = {
  NAME: "name",
  ID: "id",
} as const;

export type ProductSort = typeof ProductSort[keyof typeof ProductSort];

export type PublicSearchSites = {
  addressQuery?: string | null;
  by: SitesSortFields;
  clientIds?: Array<string> | null;
  order: SortOrder;
  page: number;
  pageSize: number;
  proximity?: Circle | null;
  query?: string | null;
  siteIds?: Array<string> | null;
};

export type PublicSearchSpotClasses = {
  dateRange: RangeOfDate;
  siteIds: Array<string>;
};

export type PublicSiteRow = {
  address?: string | null;
  city?: string | null;
  clientId?: string | null;
  code: string;
  id: string;
  name: string;
  spotCount: number;
};

export type Queue = {
  allowResidentalVatFree: boolean;
  createdAt: DateTime;
  id: string;
  name: string;
  presentation: string;
  showPriceWithVat: boolean;
  steps: Array<QueueStep>;
  updatedAt?: DateTime | null;
};

export type QueueApplicant = {
  agreementApproved: boolean;
  agreementId?: string | null;
  createdAt: DateTime;
  debtor?: DebtorRef | null;
  email?: EmailAddress | null;
  enqueuedAt: DateTime;
  id: string;
  notes?: string | null;
  preferredStartDate?: _Date | null;
  queueId: string;
  refresh?: QueueApplicantRefresh | null;
  updatedAt?: DateTime | null;
  volition: QueueApplicantVolition;
  wantsResidentalVatFree?: boolean | null;
};

export type QueueApplicantData = {
  preferredStartDate?: _Date | null;
  volition: QueueApplicantVolition;
  wantsResidentalVatFree?: boolean | null;
};

export type QueueApplicantRef = {
  applicantId: string;
  queueId: string;
  queueName: string;
};

export type QueueApplicantRefresh = {
  reminderSentAt?: DateTime | null;
  requestExpiresAt: DateTime;
  requestSentAt: DateTime;
};

export type QueueApplicantTag = {
  tagId: string;
};

export type QueueApplicantVolition = {
  first: {
    tags: Array<QueueApplicantTag>;
  };
} | {
  more: {
    tags: Array<QueueApplicantTag>;
  };
} | {
  swapToTags: {
    fromAgreementSpotId: string;
    tags: Array<QueueApplicantTag>;
  };
} | {
  swapToSpots: {
    fromAgreementSpotId: string;
    spotIds: Array<string>;
  };
};

export type QueueAvailability = {
  freeCount: number;
  highestPrice?: SpotPrice | null;
  lowestPrice?: SpotPrice | null;
  totalCount: number;
};

export type QueueData = {
  allowResidentalVatFree: boolean;
  name: string;
  presentation: string;
  showPriceWithVat: boolean;
};

export type QueueId = {
  /**
   * Queue id
   */
  id: string;
};

export type QueueStep = {
  data: QueueStepData;
  id: string;
  queueId: string;
  tags: Array<QueueStepTag>;
};

export type QueueStepData = {
  description?: string | null;
  stepNr: number;
};

export type QueueStepId = {
  /**
   * Queue id
   */
  queueId: string;
  /**
   * Step id
   */
  stepId: string;
};

export type QueueStepTag = {
  checkedByDefault?: boolean;
  tagId: string;
};

export type QueueTag = {
  site: SiteRef;
  stepId: string;
  stepNr: number;
  tag: Tag;
};

export type QueueTagsAvailability = {
  availability: QueueAvailability;
  tags: Array<QueueTag>;
};

export type RangeOfDate = {
  end: _Date;
  start: _Date;
};

export type RegisterFcmToken = {
  fcmToken: string;
};

export type RentalInfo = {
  address?: string | null;
  city?: string | null;
  name?: string | null;
  orgnr?: Organisationsnummer | null;
  position?: Coordinates | null;
  siteId: string;
  updatedAt?: DateTime | null;
  zip?: string | null;
};

export type RentalInfoData = {
  address?: string | null;
  city?: string | null;
  name?: string | null;
  orgnr?: Organisationsnummer | null;
  position?: Coordinates | null;
  zip?: string | null;
};

export type SearchAccessCodeSeries = {
  ids?: Array<string> | null;
  page?: number | null;
  pageSize?: number | null;
  siteIds?: Array<string> | null;
  spotIds?: Array<string> | null;
};

export type SearchAgreements = {
  debtorIds?: Array<string>;
  pagination?: Paginate;
  query?: string;
  siteIds?: Array<string>;
  sort?: SortForSortAgreements;
  stateFilters?: Array<SearchAgreementsFilterField>;
};

export const SearchAgreementsFilterField = {
  DRAFT: "draft",
  PRE_APPROVED: "preApproved",
  OFFERED: "offered",
  OFFER_DECLINED: "offerDeclined",
  OFFER_EXPIRED: "offerExpired",
  APPROVED: "approved",
  ACTIVE: "active",
  ENDING: "ending",
  ENDED: "ended",
} as const;

export type SearchAgreementsFilterField =
  typeof SearchAgreementsFilterField[keyof typeof SearchAgreementsFilterField];

export type SearchClients = {
  paginate: Paginate;
};

export type SearchDebtors = {
  pagination?: Paginate;
  query?: string | null;
  siteId?: string | null;
  sort?: SortForSortDebtors;
};

export type SearchEmails = {
  page: number;
  pageSize: number;
  recipient?: string | null;
  subject?: string | null;
};

export type SearchEntrances = {
  pagination?: Paginate;
  query?: string | null;
  siteId?: string | null;
  sort?: SortForSortEntrances;
};

export type SearchGrants = {
  paginate: Paginate;
  userIds: Array<string>;
};

export const SearchIndex = {
  DEBTORS: "Debtors",
  AGREEMENTS: "Agreements",
  PARK46: "Park46",
  SPOTS: "Spots",
} as const;

export type SearchIndex = typeof SearchIndex[keyof typeof SearchIndex];

export type SearchP46Debtors = {
  facilityId?: string | null;
  pagination?: Paginate;
  query?: string | null;
  sort?: SortForSortP46Debtors;
};

export type SearchP46Sites = {
  pagination?: Paginate;
  query?: string | null;
  sort?: SortForSortP46Sites;
};

export type SearchPayments = {
  page?: number | null;
  pageSize?: number | null;
};

export type SearchPermitSessions = {
  pagination: Paginate;
  permit_ids: Array<string>;
};

export type SearchQueueTags = {
  selectedTags?: Array<string> | null;
};

export type SearchResponseForAgreement = {
  items: Array<Agreement>;
  page: number;
  pageCount: number;
  pageSize: number;
  processingTimeMs: number;
  query: string;
  totalCount: number;
};

export type SearchResponseForIndexedDebtor = {
  items: Array<IndexedDebtor>;
  page: number;
  pageCount: number;
  pageSize: number;
  processingTimeMs: number;
  query: string;
  totalCount: number;
};

export type SearchResponseForMyPagesSpot = {
  items: Array<MyPagesSpot>;
  page: number;
  pageCount: number;
  pageSize: number;
  processingTimeMs: number;
  query: string;
  totalCount: number;
};

export type SearchResponseForP46Debtor = {
  items: Array<P46Debtor>;
  page: number;
  pageCount: number;
  pageSize: number;
  processingTimeMs: number;
  query: string;
  totalCount: number;
};

export type SearchResponseForP46Site = {
  items: Array<P46Site>;
  page: number;
  pageCount: number;
  pageSize: number;
  processingTimeMs: number;
  query: string;
  totalCount: number;
};

export type SearchResponseForSpot = {
  items: Array<Spot>;
  page: number;
  pageCount: number;
  pageSize: number;
  processingTimeMs: number;
  query: string;
  totalCount: number;
};

export type SearchSites = {
  addressQuery?: string | null;
  by: SitesSortFields;
  clientIds?: Array<string> | null;
  migrated?: SitesMigratedFilter | null;
  order: SortOrder;
  page: number;
  pageSize: number;
  proximity?: Circle | null;
  query?: string | null;
  siteIds?: Array<string> | null;
};

export type SearchSpotClasses = {
  dateRange: RangeOfDate;
  siteIds: Array<string>;
};

export type SearchSpotShares = {
  pagination?: Paginate;
  query?: string;
  siteIds?: Array<string>;
  sort?: SortForSortSpotShares;
  spotIds?: Array<string>;
  validAfter?: DateTime | null;
  validBefore?: DateTime | null;
};

export type SearchSpots = {
  pagination: Paginate;
  siteIds: Array<string>;
};

export type SearchSpots2 = {
  groupFiltering?: SpotGroupFiltering;
  kind?: SpotKind | null;
  pagination?: Paginate;
  query?: string | null;
  siteIds?: Array<string> | null;
  sort?: SortForSortSpot;
  statusFiltering?: SpotStatusFiltering;
  tagIds?: Array<string> | null;
};

export type SearchSpots3 = {
  /**
   * Area ids
   */
  areaIds?: Array<string> | null;
  /**
   * Spot name, used like %name% query
   */
  name?: string | null;
  pagination?: Paginate | null;
  /**
   * Tag ids
   */
  tagIds?: Array<string> | null;
};

export type SearchSystemClients = {
  clientIds: Array<string>;
  query?: string | null;
};

export type SearchSystemPayments = {
  page?: number | null;
  pageSize?: number | null;
};

export type SearchSystemSites = {
  clientIds?: Array<string>;
  query?: string | null;
  siteIds?: Array<string>;
};

export type SentEmail = {
  error?: string | null;
  id: string;
  recipients: Array<EmailRecipient>;
  sentAt: DateTime;
  state: EmailState;
  subject: string;
};

export type Site = {
  activeSince?: DateTime | null;
  clientId?: string | null;
  code: string;
  completedAt?: DateTime | null;
  createdAt: DateTime;
  creditorId?: string | null;
  id: string;
  migratedAt?: DateTime | null;
  name: string;
  rentalInfo?: RentalInfo | null;
  updatedAt?: DateTime | null;
};

export type SiteAccess = {
  agreements: Array<AgreementAccess>;
  entrances: Array<Entrance>;
  id: string;
  imageUrl?: string | null;
  maxAccessTo?: DateTime | null;
  minAccessFrom?: DateTime | null;
  name: string;
  permitGrants: Array<PermitGrant>;
  rentalInfo?: RentalInfo | null;
  spots: Array<SpotAccess>;
};

export type SiteAndAreaIds = {
  /**
   * Site id
   */
  area_id: string;
  /**
   * Site id
   */
  site_id: string;
};

export type SiteConnections = {
  easyparkCodes: Array<number>;
  hojabCodes: Array<string>;
  parknpayProjectCodes: Array<string>;
  parksterCodes: Array<string>;
};

export type SiteData = {
  activeSince?: DateTime | null;
  clientId?: string | null;
  code: string;
  completedAt?: DateTime | null;
  name: string;
};

export type SiteId = {
  /**
   * Site id
   */
  id: string;
};

export type SiteId2 = {
  /**
   * Site id
   */
  id: string;
};

export type SiteIds = {
  /**
   * Site ids
   */
  ids: Array<string>;
};

export type SiteRef = {
  clientId?: string | null;
  code: string;
  id: string;
  migratedAt?: DateTime | null;
  name: string;
};

export type SiteRow = {
  address?: string | null;
  city?: string | null;
  clientId?: string | null;
  code: string;
  id: string;
  name: string;
  spotCount: number;
};

export type SiteStats = {
  agreements: AgreementStats;
  siteId: string;
  spots: SpotStats;
  tags: Array<TagStats>;
};

export const SitesMigratedFilter = {
  ALL: "all",
  MIGRATED: "migrated",
  NOT_MIGRATED: "notMigrated",
} as const;

export type SitesMigratedFilter =
  typeof SitesMigratedFilter[keyof typeof SitesMigratedFilter];

export const SitesSortFields = {
  CODE: "code",
  NAME: "name",
  PROXIMITY: "proximity",
} as const;

export type SitesSortFields =
  typeof SitesSortFields[keyof typeof SitesSortFields];

export type SkippedBillectaProduct = {
  creditorId: string;
  productId: string;
  reason: string;
  remoteId?: string | null;
  remoteVatId?: string | null;
};

export type SmsDelivery = {
  phone: string;
};

export const SortAgreements = {
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  APPROVED_AT: "approvedAt",
  START_DATE: "startDate",
  END_DATE: "endDate",
  INVOICED_FROM: "invoicedFrom",
  DEBTOR_NAME: "debtorName",
} as const;

export type SortAgreements = typeof SortAgreements[keyof typeof SortAgreements];

export const SortDebtors = {
  NAME: "name",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  CONTACT_EMAIL: "contactEmail",
  INVOICE_EMAIL: "invoiceEmail",
} as const;

export type SortDebtors = typeof SortDebtors[keyof typeof SortDebtors];

export const SortEntrances = {
  NAME: "name",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
} as const;

export type SortEntrances = typeof SortEntrances[keyof typeof SortEntrances];

export const SortOrder = {
  ASC: "asc",
  DESC: "desc",
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];

export const SortP46Debtors = {
  NAME: "name",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  EMAIL: "email",
  ORGANISATIONSNUMMER: "organisationsnummer",
  PERSONNUMMER: "personnummer",
} as const;

export type SortP46Debtors = typeof SortP46Debtors[keyof typeof SortP46Debtors];

export const SortP46Sites = {
  NAME: "name",
  PROJECT: "project",
} as const;

export type SortP46Sites = typeof SortP46Sites[keyof typeof SortP46Sites];

export const SortSpot = {
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  NUMERIC_NAME: "numericName",
  NAME: "name",
  SUB_PRICE: "subPrice",
  VAT_FREE_PRICE: "vatFreePrice",
} as const;

export type SortSpot = typeof SortSpot[keyof typeof SortSpot];

export const SortSpotShares = {
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  VALID_FROM: "validFrom",
  VALID_UNTIL: "validUntil",
  ACCEPTED_AT: "acceptedAt",
  AGREEMENT_NUMBER: "agreementNumber",
  SPOT_NAME: "spotName",
  SPOT_NUMERIC_NAME: "spotNumericName",
} as const;

export type SortSpotShares = typeof SortSpotShares[keyof typeof SortSpotShares];

export type SortForProductSort = {
  by: ProductSort;
  order: SortOrder;
};

export type SortForSortAgreements = {
  by: SortAgreements;
  order: SortOrder;
};

export type SortForSortDebtors = {
  by: SortDebtors;
  order: SortOrder;
};

export type SortForSortEntrances = {
  by: SortEntrances;
  order: SortOrder;
};

export type SortForSortP46Debtors = {
  by: SortP46Debtors;
  order: SortOrder;
};

export type SortForSortP46Sites = {
  by: SortP46Sites;
  order: SortOrder;
};

export type SortForSortSpot = {
  by: SortSpot;
  order: SortOrder;
};

export type SortForSortSpotShares = {
  by: SortSpotShares;
  order: SortOrder;
};

export type Spot = {
  accessCodeRef?: AccessCodeSeriesRef | null;
  accessCodeSeriesId?: string | null;
  agreementPeriod?: Interval | null;
  area?: AreaRef | null;
  belongsToGroup?: SpotGroupRef | null;
  blockedFrom?: _Date | null;
  blockedUntil?: _Date | null;
  createdAt: DateTime;
  derivedPrice?: SpotPrice | null;
  id: string;
  kind: SpotKind;
  name: string;
  notes?: string | null;
  numericName: number;
  relevantAgreements: Array<AgreementRef>;
  siteId: string;
  spotGroup?: SpotGroup | null;
  tagIds?: Array<string>;
  tags: Array<TagRef>;
  updatedAt?: DateTime | null;
};

export type SpotAccess = {
  accessFrom: DateTime;
  accessTo?: DateTime | null;
  name: string;
  siteId: string;
  spotId: string;
};

export type SpotBatchCreate = {
  accessCodeSeriesId?: string | null;
  agreementPeriod?: Interval | null;
  kind: SpotKind;
  notes?: string | null;
  numberLen?: number | null;
  prefix?: string | null;
  rangeStart: number;
  rangeStop: number;
  siteId: string;
  suffix?: string | null;
  tagIds?: Array<string> | null;
};

export type SpotBatchUpdate = {
  addTags?: Array<string> | null;
  blockedFrom?: SpotBlockAction | null;
  blockedUntil?: SpotBlockAction | null;
  notes?: string | null;
  removeTags?: Array<string> | null;
  spotIds: Array<string>;
};

export type SpotBlockAction = "clear" | {
  set: _Date;
};

export type SpotClass = {
  availability: Availability;
  isPopular: boolean;
  price: Price;
  productKind: ProductKind;
  tags: Array<Tag>;
};

export type SpotClassSpotSearch = {
  isGroup?: boolean | null;
  tagIds: Array<string>;
};

export type SpotData = {
  accessCodeSeriesId?: string | null;
  agreementPeriod?: Interval | null;
  blockedFrom?: _Date | null;
  blockedUntil?: _Date | null;
  kind: SpotKind;
  name: string;
  notes?: string | null;
  numericName: number;
  spotGroup?: SpotGroup | null;
};

export type SpotGroup = {
  capacity: number;
  size: number;
};

export const SpotGroupFiltering = {
  NON_GROUPED: "nonGrouped",
  ONLY_GROUPS: "onlyGroups",
  ALL: "all",
} as const;

export type SpotGroupFiltering =
  typeof SpotGroupFiltering[keyof typeof SpotGroupFiltering];

export type SpotGroupRef = {
  accessCodeSeriesId?: string | null;
  agreementPeriod?: Interval | null;
  blockedFrom?: _Date | null;
  blockedUntil?: _Date | null;
  group_size: number;
  id: string;
  kind: SpotKind;
  name: string;
  notes?: string | null;
  numericName: number;
  spotGroup?: SpotGroup | null;
};

export type SpotId = {
  /**
   * Spot id
   */
  id: string;
};

export const SpotKind = {
  GARAGE: "garage",
  OUTDOORS: "outdoors",
} as const;

export type SpotKind = typeof SpotKind[keyof typeof SpotKind];

export type SpotPrice = {
  normal: Price;
  residental: Price;
};

export type SpotRef = {
  id: string;
  name: string;
  numeric_name: number;
};

export type SpotShare = {
  acceptedAt?: DateTime | null;
  createdAt: DateTime;
  grantedBy: UserRef;
  id: string;
  sentToEmail: EmailAddress;
  sharedVia?: SpotShareViaAgreement | null;
  siteId: string;
  siteName: string;
  spot: SpotRef;
  updatedAt?: DateTime | null;
  user?: UserRef | null;
  validFrom: DateTime;
  validUntil?: DateTime | null;
};

export type SpotShareId = {
  /**
   * SpotShare id
   */
  id: string;
};

export type SpotShareViaAgreement = {
  agreement: AgreementRef;
  agreement_spot_id: string;
};

export type SpotStats = {
  occupiedCount: number;
  totalCount: number;
  totalValue: Amount;
};

export const SpotStatusFiltering = {
  ALL: "all",
  FREE: "free",
  ACTIVE: "active",
} as const;

export type SpotStatusFiltering =
  typeof SpotStatusFiltering[keyof typeof SpotStatusFiltering];

export type SpotsSetArea = {
  area_id?: string | null;
  spot_ids: Array<string>;
};

export type StartLogin = {
  ip?: string | null;
  method: AuthMethod;
};

export type StoreTestLogin = {
  code: string;
};

export type StoreTestReply = {
  jwt: string;
  user: User;
};

export type SupportInfo = {
  content: string;
  createdAt: DateTime;
  siteId: string;
  updatedAt?: DateTime | null;
};

export type SwedishId = {
  person: Personnummer;
} | {
  organisation: Organisationsnummer;
};

export type SyncProductsOutome = {
  skippedBillectaProducts: Array<SkippedBillectaProduct>;
  syncedBillectaProductsCount: number;
  syncedProductsCount: number;
};

export type SystemClient = {
  created_at: DateTime;
  id: string;
  name: string;
  updated_at?: DateTime | null;
};

export type SystemSite = {
  client_id?: string | null;
  code: string;
  created_at: DateTime;
  id: string;
  name: string;
  updated_at?: DateTime | null;
};

export type Tag = {
  color?: Color | null;
  createdAt: DateTime;
  description?: string | null;
  id: string;
  internalDescription?: string | null;
  isInternal?: boolean;
  name: string;
  pricing?: TagPricing | null;
  siteId: string;
  updatedAt?: DateTime | null;
};

export type TagData = {
  color?: Color | null;
  description?: string | null;
  internalDescription?: string | null;
  isInternal?: boolean;
  name: string;
  pricing?: TagPricing | null;
  siteId: string;
};

export type TagId = {
  /**
   * Tag id
   */
  id: string;
};

export type TagIds = {
  /**
   * List of tag ids
   */
  tagIds: Array<string>;
};

export type TagPricing = {
  price: Amount;
  productId: string;
  residentalVatFree: boolean;
};

export type TagRef = {
  id: string;
  isInternal: boolean;
  name: string;
};

export type TagStats = {
  spotCount: number;
  tag: Tag;
};

export type TagWithAssociations = {
  spots: Array<Spot>;
  tag: Tag;
};

export type Terms = {
  content?: string | null;
  createdAt: DateTime;
  updatedAt?: DateTime | null;
};

export type UpdateLicensePlate = {
  licensePlate: LicensePlate;
};

export type UpdateLicensePlateOutcome = {
  endedSession?: PermitSession | null;
  grant: PermitGrant;
};

export type UpdateSpotShare = {
  validUntil?: DateTime | null;
};

export type User = {
  accesses: Array<Access>;
  email?: EmailAddress | null;
  id: string;
  invited_by?: UserRef | null;
  names?: UserNames | null;
};

export type UserIds = {
  /**
   * List of user ids
   */
  userIds: Array<string>;
};

export type UserNames = {
  full: string;
  given: string;
};

export type UserRef = {
  email?: EmailAddress | null;
  id: string;
};

export type ValidateAccessCode = {
  accessCode: AccessCodeString;
};

export type Ym = number;

export type SysSearchRebuildData = {
  body: Indexes;
  path?: never;
  query?: never;
  url: "/admin/search/rebuild";
};

export type SysSearchRebuildErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SysSearchRebuildResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type AdminSyncFinnProductsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/admin/sync/finn/products";
};

export type AdminSyncFinnProductsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type AdminSyncFinnProductsResponses = {
  200: SyncProductsOutome;
};

export type AdminSyncFinnProductsResponse =
  AdminSyncFinnProductsResponses[keyof AdminSyncFinnProductsResponses];

export type SysWarnData = {
  body: LogMessage;
  path?: never;
  query?: never;
  url: "/admin/log/warning";
};

export type SysWarnErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SysWarnResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type SysErrorData = {
  body: LogMessage;
  path?: never;
  query?: never;
  url: "/admin/log/error";
};

export type SysErrorErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SysErrorResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type MasqueradeData = {
  body: MasqueradeTarget;
  path?: never;
  query?: never;
  url: "/system/masquerade";
};

export type MasqueradeErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type MasqueradeResponses = {
  200: MasqueradeResult;
};

export type MasqueradeResponse = MasqueradeResponses[keyof MasqueradeResponses];

export type SearchSystemSitesData = {
  body: SearchSystemSites;
  path?: never;
  query?: never;
  url: "/system/sites/search";
};

export type SearchSystemSitesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchSystemSitesResponses = {
  200: Array<SystemSite>;
};

export type SearchSystemSitesResponse =
  SearchSystemSitesResponses[keyof SearchSystemSitesResponses];

export type SearchSystemClientsData = {
  body: SearchSystemClients;
  path?: never;
  query?: never;
  url: "/system/clients/search";
};

export type SearchSystemClientsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchSystemClientsResponses = {
  200: Array<SystemClient>;
};

export type SearchSystemClientsResponse =
  SearchSystemClientsResponses[keyof SearchSystemClientsResponses];

export type SysSyncBillectaData = {
  body: BillectaSyncTarget;
  path?: never;
  query?: never;
  url: "/system/sync/billecta";
};

export type SysSyncBillectaErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SysSyncBillectaResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type CalculateTagTenanciesData = {
  body: CalculateSiteStats;
  path?: never;
  query?: never;
  url: "/system/reports/tag_tenancies/calculate";
};

export type CalculateTagTenanciesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CalculateTagTenanciesResponses = {
  200: CalculationOutcome;
};

export type CalculateTagTenanciesResponse =
  CalculateTagTenanciesResponses[keyof CalculateTagTenanciesResponses];

export type ClearClassificationCountsData = {
  body: ClearSiteStats;
  path?: never;
  query?: never;
  url: "/system/reports/classification_counts";
};

export type ClearClassificationCountsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ClearClassificationCountsResponses = {
  200: NumRemoved;
};

export type ClearClassificationCountsResponse =
  ClearClassificationCountsResponses[keyof ClearClassificationCountsResponses];

export type CalculateClassificationCountsData = {
  body: CalculateSiteStats;
  path?: never;
  query?: never;
  url: "/system/reports/classification_counts";
};

export type CalculateClassificationCountsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CalculateClassificationCountsResponses = {
  200: CalculationOutcome;
};

export type CalculateClassificationCountsResponse =
  CalculateClassificationCountsResponses[
    keyof CalculateClassificationCountsResponses
  ];

export type GetSentEmailData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/system/emails/{id}";
};

export type GetSentEmailErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSentEmailResponses = {
  200: SentEmail;
};

export type GetSentEmailResponse =
  GetSentEmailResponses[keyof GetSentEmailResponses];

export type SearchSentEmailsData = {
  body: SearchEmails;
  path?: never;
  query?: never;
  url: "/system/emails";
};

export type SearchSentEmailsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchSentEmailsResponses = {
  200: PaginatedForSentEmail;
};

export type SearchSentEmailsResponse =
  SearchSentEmailsResponses[keyof SearchSentEmailsResponses];

export type SystemSearchPaymentsData = {
  body: SearchSystemPayments;
  path?: never;
  query?: never;
  url: "/system/payments";
};

export type SystemSearchPaymentsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SystemSearchPaymentsResponses = {
  200: PaginatedForPaymentWithDebtor;
};

export type SystemSearchPaymentsResponse =
  SystemSearchPaymentsResponses[keyof SystemSearchPaymentsResponses];

export type LoginStoreTestData = {
  body?: never;
  path?: never;
  query: {
    code: string;
  };
  url: "/login/store-test";
};

export type LoginStoreTestResponses = {
  200: StoreTestReply;
};

export type LoginStoreTestResponse =
  LoginStoreTestResponses[keyof LoginStoreTestResponses];

export type StartLoginData = {
  body: StartLogin;
  path?: never;
  query?: never;
  url: "/login";
};

export type StartLoginResponses = {
  200: LoginStatus;
};

export type StartLoginResponse = StartLoginResponses[keyof StartLoginResponses];

export type GetLoginStatusData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/login/status/{id}";
};

export type GetLoginStatusResponses = {
  200: LoginStatus;
};

export type GetLoginStatusResponse =
  GetLoginStatusResponses[keyof GetLoginStatusResponses];

export type CancelLoginData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/login/cancel/{id}";
};

export type CancelLoginResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type AppSitesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/app/sites";
};

export type AppSitesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type AppSitesResponses = {
  200: AppSites;
};

export type AppSitesResponse = AppSitesResponses[keyof AppSitesResponses];

export type RegisterFcmTokenData = {
  body: RegisterFcmToken;
  path?: never;
  query?: never;
  url: "/app/register-fcm";
};

export type RegisterFcmTokenErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type RegisterFcmTokenResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type StartMyPagesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/mypages/start";
};

export type StartMyPagesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type StartMyPagesResponses = {
  200: MyPagesStart;
};

export type StartMyPagesResponse =
  StartMyPagesResponses[keyof StartMyPagesResponses];

export type AcceptUserInviteData = {
  body: Invite;
  path?: never;
  query?: never;
  url: "/mypages/accept-invite";
};

export type AcceptUserInviteErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type AcceptUserInviteResponses = {
  200: AcceptInviteOutcome;
};

export type AcceptUserInviteResponse =
  AcceptUserInviteResponses[keyof AcceptUserInviteResponses];

export type GetMyAgreementsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/mypages/agreements";
};

export type GetMyAgreementsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetMyAgreementsResponses = {
  200: Array<AgreementAccess>;
};

export type GetMyAgreementsResponse =
  GetMyAgreementsResponses[keyof GetMyAgreementsResponses];

export type GetMySitesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/mypages/sites";
};

export type GetMySitesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetMySitesResponses = {
  200: Array<MyPagesSite>;
};

export type GetMySitesResponse = GetMySitesResponses[keyof GetMySitesResponses];

export type SiteSearchData = {
  body: SearchSites;
  path?: never;
  query?: never;
  url: "/sites/search";
};

export type SiteSearchErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteSearchResponses = {
  200: PaginatedForSiteRow;
};

export type SiteSearchResponse = SiteSearchResponses[keyof SiteSearchResponses];

export type SiteGetAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/sites";
};

export type SiteGetAllErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteGetAllResponses = {
  200: Array<Site>;
};

export type SiteGetAllResponse = SiteGetAllResponses[keyof SiteGetAllResponses];

export type SiteCreateData = {
  body: SiteData;
  path?: never;
  query?: never;
  url: "/sites";
};

export type SiteCreateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteCreateResponses = {
  200: Site;
};

export type SiteCreateResponse = SiteCreateResponses[keyof SiteCreateResponses];

export type SiteGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}";
};

export type SiteGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteGetResponses = {
  200: Site;
};

export type SiteGetResponse = SiteGetResponses[keyof SiteGetResponses];

export type SitePutData = {
  body: SiteData;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}";
};

export type SitePutErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SitePutResponses = {
  200: Site;
};

export type SitePutResponse = SitePutResponses[keyof SitePutResponses];

export type GetSiteTermsData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/terms";
};

export type GetSiteTermsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSiteTermsResponses = {
  200: Terms | null;
};

export type GetSiteTermsResponse =
  GetSiteTermsResponses[keyof GetSiteTermsResponses];

export type SetSiteTermsData = {
  body: string;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/terms";
};

export type SetSiteTermsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetSiteTermsResponses = {
  200: Terms | null;
};

export type SetSiteTermsResponse =
  SetSiteTermsResponses[keyof SetSiteTermsResponses];

export type GetSiteSupportInfoData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/support_info";
};

export type GetSiteSupportInfoErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSiteSupportInfoResponses = {
  200: SupportInfo | null;
};

export type GetSiteSupportInfoResponse =
  GetSiteSupportInfoResponses[keyof GetSiteSupportInfoResponses];

export type SetSiteSupportInfoData = {
  body: string;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/support_info";
};

export type SetSiteSupportInfoErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetSiteSupportInfoResponses = {
  200: SupportInfo;
};

export type SetSiteSupportInfoResponse =
  SetSiteSupportInfoResponses[keyof SetSiteSupportInfoResponses];

export type SiteTagsGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/tags";
};

export type SiteTagsGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteTagsGetResponses = {
  200: Array<Tag>;
};

export type SiteTagsGetResponse =
  SiteTagsGetResponses[keyof SiteTagsGetResponses];

export type SiteAreasGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/areas";
};

export type SiteAreasGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteAreasGetResponses = {
  200: Array<Area>;
};

export type SiteAreasGetResponse =
  SiteAreasGetResponses[keyof SiteAreasGetResponses];

export type SiteAreasCreateData = {
  body: AreaData;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/areas";
};

export type SiteAreasCreateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteAreasCreateResponses = {
  200: Area;
};

export type SiteAreasCreateResponse =
  SiteAreasCreateResponses[keyof SiteAreasCreateResponses];

export type SiteAreaGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    area_id: string;
    /**
     * Site id
     */
    site_id: string;
  };
  query?: never;
  url: "/sites/{site_id}/areas/{area_id}";
};

export type SiteAreaGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteAreaGetResponses = {
  200: Area;
};

export type SiteAreaGetResponse =
  SiteAreaGetResponses[keyof SiteAreaGetResponses];

export type SiteAreasUpdateData = {
  body: AreaData;
  path: {
    /**
     * Site id
     */
    area_id: string;
    /**
     * Site id
     */
    site_id: string;
  };
  query?: never;
  url: "/sites/{site_id}/areas/{area_id}";
};

export type SiteAreasUpdateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteAreasUpdateResponses = {
  200: Area;
};

export type SiteAreasUpdateResponse =
  SiteAreasUpdateResponses[keyof SiteAreasUpdateResponses];

export type SiteConnectionsGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/connections";
};

export type SiteConnectionsGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteConnectionsGetResponses = {
  200: SiteConnections;
};

export type SiteConnectionsGetResponse =
  SiteConnectionsGetResponses[keyof SiteConnectionsGetResponses];

export type SiteConnectionsPutData = {
  body: SiteConnections;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/connections";
};

export type SiteConnectionsPutErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteConnectionsPutResponses = {
  200: SiteConnections;
};

export type SiteConnectionsPutResponse =
  SiteConnectionsPutResponses[keyof SiteConnectionsPutResponses];

export type SiteRentalInfoGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/rental_info";
};

export type SiteRentalInfoGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteRentalInfoGetResponses = {
  200: RentalInfo;
};

export type SiteRentalInfoGetResponse =
  SiteRentalInfoGetResponses[keyof SiteRentalInfoGetResponses];

export type SiteRentalInfoPutData = {
  body: RentalInfoData;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/rental_info";
};

export type SiteRentalInfoPutErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteRentalInfoPutResponses = {
  200: RentalInfo;
};

export type SiteRentalInfoPutResponse =
  SiteRentalInfoPutResponses[keyof SiteRentalInfoPutResponses];

export type SiteLenderInfoGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/lender_info";
};

export type SiteLenderInfoGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteLenderInfoGetResponses = {
  200: LenderInfo;
};

export type SiteLenderInfoGetResponse =
  SiteLenderInfoGetResponses[keyof SiteLenderInfoGetResponses];

export type SiteLenderInfoPutData = {
  body: LenderInfoData;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/lender_info";
};

export type SiteLenderInfoPutErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteLenderInfoPutResponses = {
  200: LenderInfo;
};

export type SiteLenderInfoPutResponse =
  SiteLenderInfoPutResponses[keyof SiteLenderInfoPutResponses];

export type SiteGetStatsData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/stats";
};

export type SiteGetStatsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteGetStatsResponses = {
  200: SiteStats;
};

export type SiteGetStatsResponse =
  SiteGetStatsResponses[keyof SiteGetStatsResponses];

export type SiteGetAgreementSettingsData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/agreement_settings";
};

export type SiteGetAgreementSettingsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteGetAgreementSettingsResponses = {
  200: AgreementSettings;
};

export type SiteGetAgreementSettingsResponse =
  SiteGetAgreementSettingsResponses[keyof SiteGetAgreementSettingsResponses];

export type SiteSetAgreementSettingsData = {
  body: AgreementSettingsData;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/agreement_settings";
};

export type SiteSetAgreementSettingsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteSetAgreementSettingsResponses = {
  200: AgreementSettings;
};

export type SiteSetAgreementSettingsResponse =
  SiteSetAgreementSettingsResponses[keyof SiteSetAgreementSettingsResponses];

export type SiteGetDevicesData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/devices";
};

export type SiteGetDevicesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteGetDevicesResponses = {
  200: Array<Device>;
};

export type SiteGetDevicesResponse =
  SiteGetDevicesResponses[keyof SiteGetDevicesResponses];

export type SiteGetSpotsData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/spots";
};

export type SiteGetSpotsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteGetSpotsResponses = {
  200: Array<Spot>;
};

export type SiteGetSpotsResponse =
  SiteGetSpotsResponses[keyof SiteGetSpotsResponses];

export type SiteGetQueueData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/queue";
};

export type SiteGetQueueErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteGetQueueResponses = {
  200: Queue;
};

export type SiteGetQueueResponse =
  SiteGetQueueResponses[keyof SiteGetQueueResponses];

export type SiteDisconnectCreditorData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/creditor";
};

export type SiteDisconnectCreditorErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteDisconnectCreditorResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type SiteConnectCreditorData = {
  body: string;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/sites/{id}/creditor";
};

export type SiteConnectCreditorErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteConnectCreditorResponses = {
  200: BillectaCreditor;
};

export type SiteConnectCreditorResponse =
  SiteConnectCreditorResponses[keyof SiteConnectCreditorResponses];

export type PublicSiteSearchData = {
  body: PublicSearchSites;
  path?: never;
  query?: never;
  url: "/public/store/sites/search";
};

export type PublicSiteSearchResponses = {
  200: PaginatedForPublicSiteRow;
};

export type PublicSiteSearchResponse =
  PublicSiteSearchResponses[keyof PublicSiteSearchResponses];

export type PublicSiteGetData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/public/store/sites/{id}";
};

export type PublicSiteGetResponses = {
  200: Site;
};

export type PublicSiteGetResponse =
  PublicSiteGetResponses[keyof PublicSiteGetResponses];

export type PublicSiteGetQueueData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/public/store/sites/{id}/queue";
};

export type PublicSiteGetQueueResponses = {
  200: Queue;
};

export type PublicSiteGetQueueResponse =
  PublicSiteGetQueueResponses[keyof PublicSiteGetQueueResponses];

export type PublicSearchSpotClassesData = {
  body: PublicSearchSpotClasses;
  path?: never;
  query?: never;
  url: "/public/store/spot-classes/search";
};

export type PublicSearchSpotClassesResponses = {
  200: Array<SpotClass>;
};

export type PublicSearchSpotClassesResponse =
  PublicSearchSpotClassesResponses[keyof PublicSearchSpotClassesResponses];

export type PublicSpotclassGetSpotsData = {
  body: SpotClassSpotSearch;
  path?: never;
  query?: never;
  url: "/public/store/spot-classes/spots";
};

export type PublicSpotclassGetSpotsResponses = {
  200: Array<Spot>;
};

export type PublicSpotclassGetSpotsResponse =
  PublicSpotclassGetSpotsResponses[keyof PublicSpotclassGetSpotsResponses];

export type PublicSearchSpotsData = {
  body: SearchSpots;
  path?: never;
  query?: never;
  url: "/public/store/spots/search";
};

export type PublicSearchSpotsResponses = {
  200: SearchResponseForMyPagesSpot;
};

export type PublicSearchSpotsResponse =
  PublicSearchSpotsResponses[keyof PublicSearchSpotsResponses];

export type PublicDebtorAndCardsGetData = {
  body: AuthToken;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/public/debtor/{id}";
};

export type PublicDebtorAndCardsGetResponses = {
  200: DebtorWithPaymentCards;
};

export type PublicDebtorAndCardsGetResponse =
  PublicDebtorAndCardsGetResponses[keyof PublicDebtorAndCardsGetResponses];

export type PublicDebtorSetupCardData = {
  body: AuthToken;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/public/debtor/{id}/cards";
};

export type PublicDebtorSetupCardResponses = {
  200: PaymentCardSetup;
};

export type PublicDebtorSetupCardResponse =
  PublicDebtorSetupCardResponses[keyof PublicDebtorSetupCardResponses];

export type PublicDebtorFinalizeCardSetupData = {
  body: FinalizePaymentCardSetupWithAuthToken;
  path: {
    /**
     * Debtor id
     */
    debtorId: string;
    /**
     * Setup id
     */
    setupId: string;
  };
  query?: never;
  url: "/public/debtor/{debtorId}/cards/setup/{setupId}";
};

export type PublicDebtorFinalizeCardSetupResponses = {
  200: PaymentCard;
};

export type PublicDebtorFinalizeCardSetupResponse =
  PublicDebtorFinalizeCardSetupResponses[
    keyof PublicDebtorFinalizeCardSetupResponses
  ];

export type SiteP46ImportData = {
  body: ImportP46Site;
  path?: never;
  query?: never;
  url: "/import/p46";
};

export type SiteP46ImportErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteP46ImportResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type SiteAgreementsImportData = {
  body: unknown;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: {
    agreementPeriod?: Months | null;
    invoicingStart?: _Date | null;
    noticePeriod?: Months | null;
    offerNoticePeriod?: Days | null;
  };
  url: "/import/site_agreements/{id}";
};

export type SiteAgreementsImportErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiteAgreementsImportResponses = {
  200: CsvImportOutcome;
};

export type SiteAgreementsImportResponse =
  SiteAgreementsImportResponses[keyof SiteAgreementsImportResponses];

export type ImportRollbackData = {
  body?: never;
  path: {
    importId: number;
  };
  query?: never;
  url: "/import/rollback/{importId}";
};

export type ImportRollbackErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ImportRollbackResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type SearchClientsData = {
  body: SearchClients;
  path?: never;
  query?: never;
  url: "/clients";
};

export type SearchClientsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchClientsResponses = {
  200: PaginatedForClientRow;
};

export type SearchClientsResponse =
  SearchClientsResponses[keyof SearchClientsResponses];

export type GetSpotData = {
  body?: never;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}";
};

export type GetSpotErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSpotResponses = {
  200: Spot;
};

export type GetSpotResponse = GetSpotResponses[keyof GetSpotResponses];

export type PutSpotData = {
  body: SpotData;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}";
};

export type PutSpotErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PutSpotResponses = {
  200: Spot;
};

export type PutSpotResponse = PutSpotResponses[keyof PutSpotResponses];

export type GetSpotAgreementsData = {
  body?: never;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/agreements";
};

export type GetSpotAgreementsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSpotAgreementsResponses = {
  200: Array<Agreement>;
};

export type GetSpotAgreementsResponse =
  GetSpotAgreementsResponses[keyof GetSpotAgreementsResponses];

export type ValidateAccessCodeData = {
  body: ValidateAccessCode;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/validate_acces_code";
};

export type ValidateAccessCodeResponses = {
  200: ValidateAccessCode;
};

export type ValidateAccessCodeResponse =
  ValidateAccessCodeResponses[keyof ValidateAccessCodeResponses];

export type GetSpotSharesData = {
  body?: never;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/shares";
};

export type GetSpotSharesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSpotSharesResponses = {
  200: Array<SpotShare>;
};

export type GetSpotSharesResponse =
  GetSpotSharesResponses[keyof GetSpotSharesResponses];

export type GetSpotGroupData = {
  body?: never;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/group";
};

export type GetSpotGroupErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSpotGroupResponses = {
  200: Array<Spot>;
};

export type GetSpotGroupResponse =
  GetSpotGroupResponses[keyof GetSpotGroupResponses];

export type DeleteSpotTagsData = {
  body: TagIds;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/tags";
};

export type DeleteSpotTagsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeleteSpotTagsResponses = {
  200: Array<Tag>;
};

export type DeleteSpotTagsResponse =
  DeleteSpotTagsResponses[keyof DeleteSpotTagsResponses];

export type GetSpotTagsData = {
  body?: never;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/tags";
};

export type GetSpotTagsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSpotTagsResponses = {
  200: Array<Tag>;
};

export type GetSpotTagsResponse =
  GetSpotTagsResponses[keyof GetSpotTagsResponses];

export type AddSpotTagsData = {
  body: TagIds;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/tags";
};

export type AddSpotTagsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type AddSpotTagsResponses = {
  200: Array<Tag>;
};

export type AddSpotTagsResponse =
  AddSpotTagsResponses[keyof AddSpotTagsResponses];

export type GetSpotApplicantsData = {
  body?: never;
  path: {
    /**
     * Spot id
     */
    id: string;
  };
  query?: never;
  url: "/spots/{id}/applicants";
};

export type GetSpotApplicantsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSpotApplicantsResponses = {
  200: Array<QueueApplicant>;
};

export type GetSpotApplicantsResponse =
  GetSpotApplicantsResponses[keyof GetSpotApplicantsResponses];

export type SearchSpotsData = {
  body: SearchSpots2;
  path?: never;
  query?: never;
  url: "/spots/search";
};

export type SearchSpotsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchSpotsResponses = {
  200: SearchResponseForSpot;
};

export type SearchSpotsResponse =
  SearchSpotsResponses[keyof SearchSpotsResponses];

export type BatchDeleteSpotsData = {
  body: Array<string>;
  path?: never;
  query?: never;
  url: "/spots/batch";
};

export type BatchDeleteSpotsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type BatchDeleteSpotsResponses = {
  200: Array<Spot>;
};

export type BatchDeleteSpotsResponse =
  BatchDeleteSpotsResponses[keyof BatchDeleteSpotsResponses];

export type BatchCreateSpotsData = {
  body: SpotBatchCreate;
  path?: never;
  query?: never;
  url: "/spots/batch";
};

export type BatchCreateSpotsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type BatchCreateSpotsResponses = {
  200: Array<Spot>;
};

export type BatchCreateSpotsResponse =
  BatchCreateSpotsResponses[keyof BatchCreateSpotsResponses];

export type BatchUpdateSpotsData = {
  body: SpotBatchUpdate;
  path?: never;
  query?: never;
  url: "/spots/batch";
};

export type BatchUpdateSpotsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type BatchUpdateSpotsResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type CreateSpotGroupData = {
  body: CreateSpotGroup;
  path?: never;
  query?: never;
  url: "/spots/group";
};

export type CreateSpotGroupErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreateSpotGroupResponses = {
  200: CreatedSpotGroup;
};

export type CreateSpotGroupResponse =
  CreateSpotGroupResponses[keyof CreateSpotGroupResponses];

export type SpotsSetAreaData = {
  body: SpotsSetArea;
  path?: never;
  query?: never;
  url: "/spots/area";
};

export type SpotsSetAreaErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SpotsSetAreaResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type CreateTagData = {
  body: TagData;
  path?: never;
  query?: never;
  url: "/tags";
};

export type CreateTagErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreateTagResponses = {
  200: Tag;
};

export type CreateTagResponse = CreateTagResponses[keyof CreateTagResponses];

export type DeleteTagData = {
  body?: never;
  path: {
    /**
     * Tag id
     */
    id: string;
  };
  query?: never;
  url: "/tags/{id}";
};

export type DeleteTagErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeleteTagResponses = {
  200: Tag;
};

export type DeleteTagResponse = DeleteTagResponses[keyof DeleteTagResponses];

export type GetTagData = {
  body?: never;
  path: {
    /**
     * Tag id
     */
    id: string;
  };
  query?: never;
  url: "/tags/{id}";
};

export type GetTagErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetTagResponses = {
  200: TagWithAssociations;
};

export type GetTagResponse = GetTagResponses[keyof GetTagResponses];

export type PutTagData = {
  body: TagData;
  path: {
    /**
     * Tag id
     */
    id: string;
  };
  query?: never;
  url: "/tags/{id}";
};

export type PutTagErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PutTagResponses = {
  200: Tag;
};

export type PutTagResponse = PutTagResponses[keyof PutTagResponses];

export type GetTagEntrancesData = {
  body?: never;
  path: {
    /**
     * Tag id
     */
    id: string;
  };
  query?: never;
  url: "/tags/{id}/entrances";
};

export type GetTagEntrancesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetTagEntrancesResponses = {
  200: Array<Entrance>;
};

export type GetTagEntrancesResponse =
  GetTagEntrancesResponses[keyof GetTagEntrancesResponses];

export type SetTagEntrancesData = {
  body: EntranceIds;
  path: {
    /**
     * Tag id
     */
    id: string;
  };
  query?: never;
  url: "/tags/{id}/entrances";
};

export type SetTagEntrancesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetTagEntrancesResponses = {
  200: Array<Entrance>;
};

export type SetTagEntrancesResponse =
  SetTagEntrancesResponses[keyof SetTagEntrancesResponses];

export type GetTagTermsData = {
  body?: never;
  path: {
    /**
     * Tag id
     */
    id: string;
  };
  query?: never;
  url: "/tags/{id}/terms";
};

export type GetTagTermsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetTagTermsResponses = {
  200: Terms | null;
};

export type GetTagTermsResponse =
  GetTagTermsResponses[keyof GetTagTermsResponses];

export type SetTagTermsData = {
  body: string | null;
  path: {
    /**
     * Tag id
     */
    id: string;
  };
  query?: never;
  url: "/tags/{id}/terms";
};

export type SetTagTermsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetTagTermsResponses = {
  200: Terms;
};

export type SetTagTermsResponse =
  SetTagTermsResponses[keyof SetTagTermsResponses];

export type ProductGetData = {
  body?: never;
  path: {
    /**
     * Product id
     */
    id: string;
  };
  query?: never;
  url: "/products/{id}";
};

export type ProductGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ProductGetResponses = {
  200: Product;
};

export type ProductGetResponse = ProductGetResponses[keyof ProductGetResponses];

export type ProductPutData = {
  body: ProductData;
  path: {
    /**
     * Product id
     */
    id: string;
  };
  query?: never;
  url: "/products/{id}";
};

export type ProductPutErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ProductPutResponses = {
  200: Product;
};

export type ProductPutResponse = ProductPutResponses[keyof ProductPutResponses];

export type ProductsSearchData = {
  body: ProductSearch;
  path?: never;
  query?: never;
  url: "/products/search";
};

export type ProductsSearchErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ProductsSearchResponses = {
  200: PaginatedForProductRow;
};

export type ProductsSearchResponse =
  ProductsSearchResponses[keyof ProductsSearchResponses];

export type ProductsDeleteData = {
  body: Array<string>;
  path?: never;
  query?: never;
  url: "/products/delete";
};

export type ProductsDeleteErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ProductsDeleteResponses = {
  200: Array<Product>;
};

export type ProductsDeleteResponse =
  ProductsDeleteResponses[keyof ProductsDeleteResponses];

export type ProductCreateData = {
  body: ProductData;
  path?: never;
  query?: never;
  url: "/products";
};

export type ProductCreateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ProductCreateResponses = {
  200: Product;
};

export type ProductCreateResponse =
  ProductCreateResponses[keyof ProductCreateResponses];

export type DebtorSearchData = {
  body: SearchDebtors;
  path?: never;
  query?: never;
  url: "/debtors/search";
};

export type DebtorSearchErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorSearchResponses = {
  200: SearchResponseForIndexedDebtor;
};

export type DebtorSearchResponse =
  DebtorSearchResponses[keyof DebtorSearchResponses];

export type DebtorBatchDeleteData = {
  body: DebtorIds;
  path?: never;
  query?: never;
  url: "/debtors/batch";
};

export type DebtorBatchDeleteErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorBatchDeleteResponses = {
  200: DebtorBatchDeleteResult;
};

export type DebtorBatchDeleteResponse =
  DebtorBatchDeleteResponses[keyof DebtorBatchDeleteResponses];

export type DebtorCreateData = {
  body: DebtorData;
  path?: never;
  query?: never;
  url: "/debtors";
};

export type DebtorCreateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorCreateResponses = {
  200: Debtor;
};

export type DebtorCreateResponse =
  DebtorCreateResponses[keyof DebtorCreateResponses];

export type DebtorDeleteData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}";
};

export type DebtorDeleteErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorDeleteResponses = {
  200: DebtorDeleteResult;
};

export type DebtorDeleteResponse =
  DebtorDeleteResponses[keyof DebtorDeleteResponses];

export type DebtorGetData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}";
};

export type DebtorGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetResponses = {
  200: Debtor;
};

export type DebtorGetResponse = DebtorGetResponses[keyof DebtorGetResponses];

export type DebtorPutData = {
  body: DebtorData;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}";
};

export type DebtorPutErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorPutResponses = {
  200: Debtor;
};

export type DebtorPutResponse = DebtorPutResponses[keyof DebtorPutResponses];

export type DebtorGetCardsData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/cards";
};

export type DebtorGetCardsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetCardsResponses = {
  200: Array<PaymentCard>;
};

export type DebtorGetCardsResponse =
  DebtorGetCardsResponses[keyof DebtorGetCardsResponses];

export type DebtorSetupCardData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/cards";
};

export type DebtorSetupCardErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorSetupCardResponses = {
  200: PaymentCardSetup;
};

export type DebtorSetupCardResponse =
  DebtorSetupCardResponses[keyof DebtorSetupCardResponses];

export type DebtorDeleteCardData = {
  body?: never;
  path: {
    /**
     * Card id
     */
    cardId: string;
    /**
     * Debtor id
     */
    debtorId: string;
  };
  query?: never;
  url: "/debtors/{debtorId}/cards/{cardId}";
};

export type DebtorDeleteCardErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorDeleteCardResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DebtorSetDefaultCardData = {
  body?: never;
  path: {
    /**
     * Card id
     */
    cardId: string;
    /**
     * Debtor id
     */
    debtorId: string;
  };
  query?: never;
  url: "/debtors/{debtorId}/cards/{cardId}";
};

export type DebtorSetDefaultCardErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorSetDefaultCardResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DebtorFinalizeCardSetupData = {
  body: FinalizePaymentCardSetup;
  path: {
    /**
     * Debtor id
     */
    debtorId: string;
    /**
     * Setup id
     */
    setupId: string;
  };
  query?: never;
  url: "/debtors/{debtorId}/cards/setup/{setupId}";
};

export type DebtorFinalizeCardSetupErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorFinalizeCardSetupResponses = {
  200: PaymentCard;
};

export type DebtorFinalizeCardSetupResponse =
  DebtorFinalizeCardSetupResponses[keyof DebtorFinalizeCardSetupResponses];

export type DebtorGetDeliveryMethodData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/delivery_method";
};

export type DebtorGetDeliveryMethodErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetDeliveryMethodResponses = {
  200: DebtorDeliveryMethod;
};

export type DebtorGetDeliveryMethodResponse =
  DebtorGetDeliveryMethodResponses[keyof DebtorGetDeliveryMethodResponses];

export type DebtorSetDeliveryMethodData = {
  body: DebtorDeliveryMethod;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/delivery_method";
};

export type DebtorSetDeliveryMethodErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorSetDeliveryMethodResponses = {
  200: DebtorDeliveryMethod;
};

export type DebtorSetDeliveryMethodResponse =
  DebtorSetDeliveryMethodResponses[keyof DebtorSetDeliveryMethodResponses];

export type DebtorGetPaymentMethodData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/payment_method";
};

export type DebtorGetPaymentMethodErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetPaymentMethodResponses = {
  200: DebtorPaymentMethod;
};

export type DebtorGetPaymentMethodResponse =
  DebtorGetPaymentMethodResponses[keyof DebtorGetPaymentMethodResponses];

export type DebtorSetPaymentMethodData = {
  body: DebtorPaymentMethod;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/payment_method";
};

export type DebtorSetPaymentMethodErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorSetPaymentMethodResponses = {
  200: DebtorPaymentMethod;
};

export type DebtorSetPaymentMethodResponse =
  DebtorSetPaymentMethodResponses[keyof DebtorSetPaymentMethodResponses];

export type DebtorGetAgreementsData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/agreements";
};

export type DebtorGetAgreementsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetAgreementsResponses = {
  200: Array<Agreement>;
};

export type DebtorGetAgreementsResponse =
  DebtorGetAgreementsResponses[keyof DebtorGetAgreementsResponses];

export type DebtorRemoveUsersData = {
  body: UserIds;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/users";
};

export type DebtorRemoveUsersErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorRemoveUsersResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DebtorGetUsersData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/users";
};

export type DebtorGetUsersErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetUsersResponses = {
  200: Array<DebtorUser>;
};

export type DebtorGetUsersResponse =
  DebtorGetUsersResponses[keyof DebtorGetUsersResponses];

export type DebtorAddUserData = {
  body: CreateDebtorUser;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/users";
};

export type DebtorAddUserErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorAddUserResponses = {
  200: DebtorUser;
};

export type DebtorAddUserResponse =
  DebtorAddUserResponses[keyof DebtorAddUserResponses];

export type ResendUserInviteData = {
  body: Id;
  path?: never;
  query?: never;
  url: "/debtors/resend_user_invite";
};

export type ResendUserInviteErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ResendUserInviteResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DebtorGetApplicantsData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/applicants";
};

export type DebtorGetApplicantsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetApplicantsResponses = {
  200: Array<QueueApplicantRef>;
};

export type DebtorGetApplicantsResponse =
  DebtorGetApplicantsResponses[keyof DebtorGetApplicantsResponses];

export type DebtorGetInvoicesData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query: {
    page: number;
    pageSize: number;
  };
  url: "/debtors/{id}/invoices";
};

export type DebtorGetInvoicesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetInvoicesResponses = {
  200: Array<DebtorInvoiceSub>;
};

export type DebtorGetInvoicesResponse =
  DebtorGetInvoicesResponses[keyof DebtorGetInvoicesResponses];

export type DebtorGetInvoicePdfData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    debtorId: string;
    invoiceId: number;
  };
  query?: never;
  url: "/debtors/{debtorId}/invoices/{invoiceId}/pdf";
};

export type DebtorGetInvoicePdfErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorGetInvoicePdfResponses = {
  /**
   * Base64
   */
  200: Base64;
};

export type DebtorGetInvoicePdfResponse =
  DebtorGetInvoicePdfResponses[keyof DebtorGetInvoicePdfResponses];

export type DebtorRequestPaymentCardData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/request-payment-card";
};

export type DebtorRequestPaymentCardErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorRequestPaymentCardResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DebtorListPaymentsData = {
  body: SearchPayments;
  path: {
    /**
     * Debtor id
     */
    id: string;
  };
  query?: never;
  url: "/debtors/{id}/payments/search";
};

export type DebtorListPaymentsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorListPaymentsResponses = {
  200: PaginatedForPayment;
};

export type DebtorListPaymentsResponse =
  DebtorListPaymentsResponses[keyof DebtorListPaymentsResponses];

export type DebtorSendPaymentReceiptData = {
  body: PostPaymentReceipt;
  path: {
    /**
     * Debtor id
     */
    debtor_id: string;
    /**
     * Payment id
     */
    payment_id: string;
  };
  query?: never;
  url: "/debtors/{debtor_id}/payments/{payment_id}/receipt";
};

export type DebtorSendPaymentReceiptErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorSendPaymentReceiptResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DebtorRefundPaymentData = {
  body?: never;
  path: {
    /**
     * Debtor id
     */
    debtor_id: string;
    /**
     * Payment id
     */
    payment_id: string;
  };
  query?: never;
  url: "/debtors/{debtor_id}/payments/{payment_id}/refund";
};

export type DebtorRefundPaymentErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DebtorRefundPaymentResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type CreateAgreementData = {
  body: AgreementUpdate;
  path?: never;
  query?: never;
  url: "/agreements";
};

export type CreateAgreementErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreateAgreementResponses = {
  200: AgreementUpdateResult;
};

export type CreateAgreementResponse =
  CreateAgreementResponses[keyof CreateAgreementResponses];

export type SearchAgreementsData = {
  body: SearchAgreements;
  path?: never;
  query?: never;
  url: "/agreements/search";
};

export type SearchAgreementsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchAgreementsResponses = {
  200: SearchResponseForAgreement;
};

export type SearchAgreementsResponse =
  SearchAgreementsResponses[keyof SearchAgreementsResponses];

export type PreApproveAgreementsData = {
  body: AgreementIds;
  path?: never;
  query?: never;
  url: "/agreements/preapprove";
};

export type PreApproveAgreementsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PreApproveAgreementsResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type ResetAgreementsToDraftData = {
  body: AgreementIds;
  path?: never;
  query?: never;
  url: "/agreements/reset-to-draft";
};

export type ResetAgreementsToDraftErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ResetAgreementsToDraftResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type OfferAgreementData = {
  body: AgreementIds;
  path?: never;
  query?: never;
  url: "/agreements/offer";
};

export type OfferAgreementErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type OfferAgreementResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type EndAgreementsData = {
  body: AgreementsWithEndDate;
  path?: never;
  query?: never;
  url: "/agreements/end";
};

export type EndAgreementsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type EndAgreementsResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DeleteAgreementsData = {
  body: AgreementIds;
  path?: never;
  query?: never;
  url: "/agreements/delete";
};

export type DeleteAgreementsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeleteAgreementsResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type GetAgreementData = {
  body?: never;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}";
};

export type GetAgreementErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetAgreementResponses = {
  200: Agreement;
};

export type GetAgreementResponse =
  GetAgreementResponses[keyof GetAgreementResponses];

export type UpdateAgreementData = {
  body: AgreementUpdate;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}";
};

export type UpdateAgreementErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type UpdateAgreementResponses = {
  200: AgreementUpdateResult;
};

export type UpdateAgreementResponse =
  UpdateAgreementResponses[keyof UpdateAgreementResponses];

export type GetAgreementSharesData = {
  body?: never;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}/shares";
};

export type GetAgreementSharesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetAgreementSharesResponses = {
  200: Array<SpotShare>;
};

export type GetAgreementSharesResponse =
  GetAgreementSharesResponses[keyof GetAgreementSharesResponses];

export type GetAgreementPdfData = {
  body?: never;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}/pdf";
};

export type GetAgreementPdfErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetAgreementPdfResponses = {
  /**
   * Base64
   */
  200: Base64;
};

export type GetAgreementPdfResponse =
  GetAgreementPdfResponses[keyof GetAgreementPdfResponses];

export type SetAgreementPdfData = {
  /**
   * Base64
   */
  body: Base64;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}/pdf";
};

export type SetAgreementPdfErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetAgreementPdfResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type GetAgreementAdditionalTermsData = {
  body?: never;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}/additional_terms";
};

export type GetAgreementAdditionalTermsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetAgreementAdditionalTermsResponses = {
  200: Terms | null;
};

export type GetAgreementAdditionalTermsResponse =
  GetAgreementAdditionalTermsResponses[
    keyof GetAgreementAdditionalTermsResponses
  ];

export type SetAgreementAdditionalTermsData = {
  body: string | null;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}/additional_terms";
};

export type SetAgreementAdditionalTermsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetAgreementAdditionalTermsResponses = {
  200: Terms;
};

export type SetAgreementAdditionalTermsResponse =
  SetAgreementAdditionalTermsResponses[
    keyof SetAgreementAdditionalTermsResponses
  ];

export type GetAgreementFullTermsData = {
  body?: never;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}/full_terms";
};

export type GetAgreementFullTermsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetAgreementFullTermsResponses = {
  200: Array<Terms>;
};

export type GetAgreementFullTermsResponse =
  GetAgreementFullTermsResponses[keyof GetAgreementFullTermsResponses];

export type ReplyToAgreementOfferData = {
  /**
   * A reply to an offerred agreement.
   */
  body: AgreementOfferReply;
  path: {
    /**
     * Agreement id
     */
    id: string;
  };
  query?: never;
  url: "/agreements/{id}/offer/reply";
};

export type ReplyToAgreementOfferErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ReplyToAgreementOfferResponses = {
  200: Agreement;
};

export type ReplyToAgreementOfferResponse =
  ReplyToAgreementOfferResponses[keyof ReplyToAgreementOfferResponses];

export type Park46SearchDebtorsData = {
  body: SearchP46Debtors;
  path?: never;
  query?: never;
  url: "/park46/debtors";
};

export type Park46SearchDebtorsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type Park46SearchDebtorsResponses = {
  200: SearchResponseForP46Debtor;
};

export type Park46SearchDebtorsResponse =
  Park46SearchDebtorsResponses[keyof Park46SearchDebtorsResponses];

export type Park46SearchSitesData = {
  body: SearchP46Sites;
  path?: never;
  query?: never;
  url: "/park46/sites";
};

export type Park46SearchSitesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type Park46SearchSitesResponses = {
  200: SearchResponseForP46Site;
};

export type Park46SearchSitesResponse =
  Park46SearchSitesResponses[keyof Park46SearchSitesResponses];

export type CreateDeviceData = {
  body: DeviceData;
  path?: never;
  query?: never;
  url: "/devices";
};

export type CreateDeviceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreateDeviceResponses = {
  200: Device;
};

export type CreateDeviceResponse =
  CreateDeviceResponses[keyof CreateDeviceResponses];

export type DeleteDevicesData = {
  body: Array<string>;
  path?: never;
  query?: never;
  url: "/devices/bulk";
};

export type DeleteDevicesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeleteDevicesResponses = {
  200: Array<Device>;
};

export type DeleteDevicesResponse =
  DeleteDevicesResponses[keyof DeleteDevicesResponses];

export type GetDeviceData = {
  body?: never;
  path: {
    /**
     * Device id
     */
    id: string;
  };
  query?: never;
  url: "/devices/{id}";
};

export type GetDeviceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetDeviceResponses = {
  200: Device;
};

export type GetDeviceResponse = GetDeviceResponses[keyof GetDeviceResponses];

export type PutDeviceData = {
  body: DeviceData;
  path: {
    /**
     * Device id
     */
    id: string;
  };
  query?: never;
  url: "/devices/{id}";
};

export type PutDeviceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PutDeviceResponses = {
  200: Device;
};

export type PutDeviceResponse = PutDeviceResponses[keyof PutDeviceResponses];

export type ActuateDeviceData = {
  body?: never;
  path: {
    /**
     * Device id
     */
    id: string;
  };
  query?: never;
  url: "/devices/{id}/actuate";
};

export type ActuateDeviceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ActuateDeviceResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type CreateEntranceData = {
  body: NewEntrance;
  path?: never;
  query?: never;
  url: "/entrances";
};

export type CreateEntranceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreateEntranceResponses = {
  200: Entrance;
};

export type CreateEntranceResponse =
  CreateEntranceResponses[keyof CreateEntranceResponses];

export type SearchEntranceData = {
  body: SearchEntrances;
  path?: never;
  query?: never;
  url: "/entrances/search";
};

export type SearchEntranceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchEntranceResponses = {
  200: PaginatedForEntrance;
};

export type SearchEntranceResponse =
  SearchEntranceResponses[keyof SearchEntranceResponses];

export type DeleteEntranceData = {
  body?: never;
  path: {
    /**
     * Entrance id
     */
    id: string;
  };
  query?: never;
  url: "/entrances/{id}";
};

export type DeleteEntranceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeleteEntranceResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type GetEntranceData = {
  body?: never;
  path: {
    /**
     * Entrance id
     */
    id: string;
  };
  query?: never;
  url: "/entrances/{id}";
};

export type GetEntranceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetEntranceResponses = {
  200: Entrance;
};

export type GetEntranceResponse =
  GetEntranceResponses[keyof GetEntranceResponses];

export type PutEntranceData = {
  body: EntranceData;
  path: {
    /**
     * Entrance id
     */
    id: string;
  };
  query?: never;
  url: "/entrances/{id}";
};

export type PutEntranceErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PutEntranceResponses = {
  200: Entrance;
};

export type PutEntranceResponse =
  PutEntranceResponses[keyof PutEntranceResponses];

export type GetEntranceTagsData = {
  body?: never;
  path: {
    /**
     * Entrance id
     */
    id: string;
  };
  query?: never;
  url: "/entrances/{id}/tags";
};

export type GetEntranceTagsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetEntranceTagsResponses = {
  200: Array<Tag>;
};

export type GetEntranceTagsResponse =
  GetEntranceTagsResponses[keyof GetEntranceTagsResponses];

export type SetEntranceTagsData = {
  body: TagIds;
  path: {
    /**
     * Entrance id
     */
    id: string;
  };
  query?: never;
  url: "/entrances/{id}/tags";
};

export type SetEntranceTagsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetEntranceTagsResponses = {
  200: Array<Tag>;
};

export type SetEntranceTagsResponse =
  SetEntranceTagsResponses[keyof SetEntranceTagsResponses];

export type GetEntranceDevicesData = {
  body?: never;
  path: {
    /**
     * Entrance id
     */
    id: string;
  };
  query?: never;
  url: "/entrances/{id}/devices";
};

export type GetEntranceDevicesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetEntranceDevicesResponses = {
  200: Array<Device>;
};

export type GetEntranceDevicesResponse =
  GetEntranceDevicesResponses[keyof GetEntranceDevicesResponses];

export type SetEntranceDevicesData = {
  body: DeviceIds;
  path: {
    /**
     * Entrance id
     */
    id: string;
  };
  query?: never;
  url: "/entrances/{id}/devices";
};

export type SetEntranceDevicesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SetEntranceDevicesResponses = {
  200: Array<Device>;
};

export type SetEntranceDevicesResponse =
  SetEntranceDevicesResponses[keyof SetEntranceDevicesResponses];

export type SearchSpotSharesData = {
  body: SearchSpotShares;
  path?: never;
  query?: never;
  url: "/spot_shares/search";
};

export type SearchSpotSharesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchSpotSharesResponses = {
  200: PaginatedForSpotShare;
};

export type SearchSpotSharesResponse =
  SearchSpotSharesResponses[keyof SearchSpotSharesResponses];

export type AcceptSpotShareData = {
  body: string;
  path: {
    /**
     * SpotShare id
     */
    id: string;
  };
  query?: never;
  url: "/spot_shares/{id}/accept";
};

export type AcceptSpotShareErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type AcceptSpotShareResponses = {
  200: SpotShare;
};

export type AcceptSpotShareResponse =
  AcceptSpotShareResponses[keyof AcceptSpotShareResponses];

export type DeleteSpotShareData = {
  body?: never;
  path: {
    /**
     * SpotShare id
     */
    id: string;
  };
  query?: never;
  url: "/spot_shares/{id}";
};

export type DeleteSpotShareErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeleteSpotShareResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type GetSpotShareData = {
  body?: never;
  path: {
    /**
     * SpotShare id
     */
    id: string;
  };
  query?: never;
  url: "/spot_shares/{id}";
};

export type GetSpotShareErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetSpotShareResponses = {
  200: SpotShare;
};

export type GetSpotShareResponse =
  GetSpotShareResponses[keyof GetSpotShareResponses];

export type UpdateSpotShareData = {
  body: UpdateSpotShare;
  path: {
    /**
     * SpotShare id
     */
    id: string;
  };
  query?: never;
  url: "/spot_shares/{id}";
};

export type UpdateSpotShareErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type UpdateSpotShareResponses = {
  200: SpotShare;
};

export type UpdateSpotShareResponse =
  UpdateSpotShareResponses[keyof UpdateSpotShareResponses];

export type CreateSpotShareData = {
  body: CreateSpotShare;
  path?: never;
  query?: never;
  url: "/spot_shares";
};

export type CreateSpotShareErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreateSpotShareResponses = {
  200: SpotShare;
};

export type CreateSpotShareResponse =
  CreateSpotShareResponses[keyof CreateSpotShareResponses];

export type QueueGetData = {
  body?: never;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}";
};

export type QueueGetResponses = {
  200: Queue;
};

export type QueueGetResponse = QueueGetResponses[keyof QueueGetResponses];

export type QueuePutData = {
  body: QueueData;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}";
};

export type QueuePutErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueuePutResponses = {
  200: Queue;
};

export type QueuePutResponse = QueuePutResponses[keyof QueuePutResponses];

export type QueueGetAvailabilityData = {
  body: SearchQueueTags;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}/availability";
};

export type QueueGetAvailabilityErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueGetAvailabilityResponses = {
  200: QueueTagsAvailability;
};

export type QueueGetAvailabilityResponse =
  QueueGetAvailabilityResponses[keyof QueueGetAvailabilityResponses];

export type QueueSearchSpotsData = {
  body: SearchSpots3;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}/spots";
};

export type QueueSearchSpotsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueSearchSpotsResponses = {
  200: PaginatedForMyPagesSpot;
};

export type QueueSearchSpotsResponse =
  QueueSearchSpotsResponses[keyof QueueSearchSpotsResponses];

export type QueueStepCreateData = {
  body: QueueStepData;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}/steps";
};

export type QueueStepCreateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueStepCreateResponses = {
  200: QueueStep;
};

export type QueueStepCreateResponse =
  QueueStepCreateResponses[keyof QueueStepCreateResponses];

export type QueueStepDeleteData = {
  body?: never;
  path: {
    /**
     * Queue id
     */
    queueId: string;
    /**
     * Step id
     */
    stepId: string;
  };
  query?: never;
  url: "/queues/{queueId}/steps/{stepId}";
};

export type QueueStepDeleteErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueStepDeleteResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type QueueStepUpdateData = {
  body: QueueStepData;
  path: {
    /**
     * Queue id
     */
    queueId: string;
    /**
     * Step id
     */
    stepId: string;
  };
  query?: never;
  url: "/queues/{queueId}/steps/{stepId}";
};

export type QueueStepUpdateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueStepUpdateResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type QueueStepSetTagsData = {
  body: Array<QueueStepTag>;
  path: {
    /**
     * Queue id
     */
    queueId: string;
    /**
     * Step id
     */
    stepId: string;
  };
  query?: never;
  url: "/queues/{queueId}/steps/{stepId}/tags";
};

export type QueueStepSetTagsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueStepSetTagsResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type QueueBulkDeleteApplicantsData = {
  body: Array<string>;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}/applicants";
};

export type QueueBulkDeleteApplicantsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueBulkDeleteApplicantsResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type QueueGetApplicantsData = {
  body?: never;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}/applicants";
};

export type QueueGetApplicantsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueGetApplicantsResponses = {
  200: Array<QueueApplicant>;
};

export type QueueGetApplicantsResponse =
  QueueGetApplicantsResponses[keyof QueueGetApplicantsResponses];

export type QueuePostApplicantData = {
  body: NewQueueApplicant;
  path: {
    /**
     * Queue id
     */
    id: string;
  };
  query?: never;
  url: "/queues/{id}/applicants";
};

export type QueuePostApplicantErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueuePostApplicantResponses = {
  200: QueueApplicant;
};

export type QueuePostApplicantResponse =
  QueuePostApplicantResponses[keyof QueuePostApplicantResponses];

export type QueueDeleteApplicantData = {
  body?: never;
  path: {
    /**
     * Applicant id
     */
    id: string;
  };
  query?: never;
  url: "/queues/applicants/{id}";
};

export type QueueDeleteApplicantErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueDeleteApplicantResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type QueueGetApplicantData = {
  body?: never;
  path: {
    /**
     * Applicant id
     */
    id: string;
  };
  query?: never;
  url: "/queues/applicants/{id}";
};

export type QueueGetApplicantErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueGetApplicantResponses = {
  200: QueueApplicant;
};

export type QueueGetApplicantResponse =
  QueueGetApplicantResponses[keyof QueueGetApplicantResponses];

export type QueueUpdateApplicantData = {
  body: QueueApplicantData;
  path: {
    /**
     * Applicant id
     */
    id: string;
  };
  query?: never;
  url: "/queues/applicants/{id}";
};

export type QueueUpdateApplicantErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueUpdateApplicantResponses = {
  200: QueueApplicant;
};

export type QueueUpdateApplicantResponse =
  QueueUpdateApplicantResponses[keyof QueueUpdateApplicantResponses];

export type QueueApplicantMatchingSpotsData = {
  body?: never;
  path: {
    /**
     * Applicant id
     */
    id: string;
  };
  query?: never;
  url: "/queues/applicants/{id}/matching_spots";
};

export type QueueApplicantMatchingSpotsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueApplicantMatchingSpotsResponses = {
  200: Array<Spot>;
};

export type QueueApplicantMatchingSpotsResponse =
  QueueApplicantMatchingSpotsResponses[
    keyof QueueApplicantMatchingSpotsResponses
  ];

export type ApplicantSetDebtorData = {
  body: DebtorId2;
  path: {
    /**
     * Applicant id
     */
    id: string;
  };
  query?: never;
  url: "/queues/applicants/{id}/debtor";
};

export type ApplicantSetDebtorErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type ApplicantSetDebtorResponses = {
  200: QueueApplicant;
};

export type ApplicantSetDebtorResponse =
  ApplicantSetDebtorResponses[keyof ApplicantSetDebtorResponses];

export type QueueApplicantsInfoRequestData = {
  body: ApplicantIds;
  path?: never;
  query?: never;
  url: "/queues/applicants/send-info-request";
};

export type QueueApplicantsInfoRequestErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type QueueApplicantsInfoRequestResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type GetAllCreditorsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/creditors/all";
};

export type GetAllCreditorsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetAllCreditorsResponses = {
  200: Array<BillectaCreditorRef>;
};

export type GetAllCreditorsResponse =
  GetAllCreditorsResponses[keyof GetAllCreditorsResponses];

export type GetCreditorData = {
  body?: never;
  path: {
    /**
     * Creditor id
     */
    id: string;
  };
  query?: never;
  url: "/creditors/{id}";
};

export type GetCreditorErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetCreditorResponses = {
  200: BillectaCreditor | null;
};

export type GetCreditorResponse =
  GetCreditorResponses[keyof GetCreditorResponses];

export type UpdateCreditorData = {
  body: BillectaCreditorData;
  path: {
    /**
     * Creditor id
     */
    id: string;
  };
  query?: never;
  url: "/creditors/{id}";
};

export type UpdateCreditorErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type UpdateCreditorResponses = {
  200: BillectaCreditor;
};

export type UpdateCreditorResponse =
  UpdateCreditorResponses[keyof UpdateCreditorResponses];

export type SiGetProductCommissionsData = {
  body?: never;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/self-invoicing/{id}/commissions";
};

export type SiGetProductCommissionsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiGetProductCommissionsResponses = {
  200: Array<ProductCommission>;
};

export type SiGetProductCommissionsResponse =
  SiGetProductCommissionsResponses[keyof SiGetProductCommissionsResponses];

export type SiPutProductCommissionData = {
  body: Array<CommissionData>;
  path: {
    /**
     * Site id
     */
    id: string;
  };
  query?: never;
  url: "/self-invoicing/{id}/commissions";
};

export type SiPutProductCommissionErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SiPutProductCommissionResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DpliteUserSearchData = {
  body: DpLiteSearch;
  path?: never;
  query?: never;
  url: "/dplite/users/search";
};

export type DpliteUserSearchErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DpliteUserSearchResponses = {
  200: Array<DpLiteUserWithAccess>;
};

export type DpliteUserSearchResponse =
  DpliteUserSearchResponses[keyof DpliteUserSearchResponses];

export type DpliteUserCreateData = {
  body: DpLiteCreateUserWithAccess;
  path?: never;
  query?: never;
  url: "/dplite/users";
};

export type DpliteUserCreateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DpliteUserCreateResponses = {
  200: DpLiteUserWithAccess;
};

export type DpliteUserCreateResponse =
  DpliteUserCreateResponses[keyof DpliteUserCreateResponses];

export type DpliteUserSetAccessData = {
  body: Array<DpLiteSetAccess>;
  path: {
    id: string;
  };
  query?: never;
  url: "/dplite/users/{id}/access";
};

export type DpliteUserSetAccessErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DpliteUserSetAccessResponses = {
  200: Array<DpLiteAccess>;
};

export type DpliteUserSetAccessResponse =
  DpliteUserSetAccessResponses[keyof DpliteUserSetAccessResponses];

export type DpliteUserSetPasswordData = {
  body: DpLiteSetPassword;
  path: {
    id: string;
  };
  query?: never;
  url: "/dplite/users/{id}/password";
};

export type DpliteUserSetPasswordErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DpliteUserSetPasswordResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type DpliteUserDeleteData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/dplite/users/{id}";
};

export type DpliteUserDeleteErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DpliteUserDeleteResponses = {
  200: DpLiteUserWithAccess;
};

export type DpliteUserDeleteResponse =
  DpliteUserDeleteResponses[keyof DpliteUserDeleteResponses];

export type DpliteUserGetData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/dplite/users/{id}";
};

export type DpliteUserGetErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DpliteUserGetResponses = {
  200: DpLiteUserWithAccess;
};

export type DpliteUserGetResponse =
  DpliteUserGetResponses[keyof DpliteUserGetResponses];

export type CreatePermitData = {
  body: PermitCreate;
  path?: never;
  query?: never;
  url: "/permits";
};

export type CreatePermitErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreatePermitResponses = {
  200: CreatePermitOutcome;
};

export type CreatePermitResponse =
  CreatePermitResponses[keyof CreatePermitResponses];

export type DeletePermitAgreementData = {
  body?: never;
  path: {
    agreement_id: string;
  };
  query?: never;
  url: "/permits/agreement/{agreement_id}";
};

export type DeletePermitAgreementErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeletePermitAgreementResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type PreviewPayPermitData = {
  body?: never;
  path: {
    agreement_id: string;
  };
  query?: never;
  url: "/permits/agreement/{agreement_id}/pay";
};

export type PreviewPayPermitErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PreviewPayPermitResponses = {
  200: PermitPayPreview;
};

export type PreviewPayPermitResponse =
  PreviewPayPermitResponses[keyof PreviewPayPermitResponses];

export type PayPermitData = {
  body?: never;
  path: {
    agreement_id: string;
  };
  query?: never;
  url: "/permits/agreement/{agreement_id}/pay";
};

export type PayPermitErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PayPermitResponses = {
  200: PayPermitOutcome;
};

export type PayPermitResponse = PayPermitResponses[keyof PayPermitResponses];

export type PreviewPayPermitPeriodData = {
  body?: never;
  path: {
    agreement_id: string;
    period: Ym;
  };
  query?: never;
  url: "/permits/agreement/{agreement_id}/pay-period/{period}";
};

export type PreviewPayPermitPeriodErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PreviewPayPermitPeriodResponses = {
  200: PermitPayPreview;
};

export type PreviewPayPermitPeriodResponse =
  PreviewPayPermitPeriodResponses[keyof PreviewPayPermitPeriodResponses];

export type PayPermitPeriodData = {
  body?: never;
  path: {
    agreement_id: string;
    period: Ym;
  };
  query?: never;
  url: "/permits/agreement/{agreement_id}/pay-period/{period}";
};

export type PayPermitPeriodErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PayPermitPeriodResponses = {
  200: PayPermitOutcome;
};

export type PayPermitPeriodResponse =
  PayPermitPeriodResponses[keyof PayPermitPeriodResponses];

export type PermitBulkDeleteGrantData = {
  body: GrantIds;
  path?: never;
  query?: never;
  url: "/permits/{permit_id}/grant";
};

export type PermitBulkDeleteGrantErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PermitBulkDeleteGrantResponses = {
  200: number;
};

export type PermitBulkDeleteGrantResponse =
  PermitBulkDeleteGrantResponses[keyof PermitBulkDeleteGrantResponses];

export type PermitCreateGrantData = {
  body: CreatePermitGrant;
  path: {
    permit_id: string;
  };
  query?: never;
  url: "/permits/{permit_id}/grant";
};

export type PermitCreateGrantErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PermitCreateGrantResponses = {
  200: PermitGrant;
};

export type PermitCreateGrantResponse =
  PermitCreateGrantResponses[keyof PermitCreateGrantResponses];

export type PermitGetGrantData = {
  body?: never;
  path: {
    grant_id: string;
  };
  query?: never;
  url: "/permits/grant/{grant_id}";
};

export type PermitGetGrantErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PermitGetGrantResponses = {
  200: PermitGrant;
};

export type PermitGetGrantResponse =
  PermitGetGrantResponses[keyof PermitGetGrantResponses];

export type SearchGrantsData = {
  body: SearchGrants;
  path?: never;
  query?: never;
  url: "/permits/grant/search";
};

export type SearchGrantsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchGrantsResponses = {
  200: PaginatedForPermitGrantInfo;
};

export type SearchGrantsResponse =
  SearchGrantsResponses[keyof SearchGrantsResponses];

export type UpdateGrantLicensePlateData = {
  body: UpdateLicensePlate;
  path: {
    grant_id: string;
  };
  query?: never;
  url: "/permits/grant/{grant_id}/license_plate";
};

export type UpdateGrantLicensePlateErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type UpdateGrantLicensePlateResponses = {
  200: UpdateLicensePlateOutcome;
};

export type UpdateGrantLicensePlateResponse =
  UpdateGrantLicensePlateResponses[keyof UpdateGrantLicensePlateResponses];

export type PermitSessionStopData = {
  body?: never;
  path: {
    grant_id: string;
  };
  query?: never;
  url: "/permits/grant/{grant_id}/session";
};

export type PermitSessionStopErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PermitSessionStopResponses = {
  200: PermitSession | null;
};

export type PermitSessionStopResponse =
  PermitSessionStopResponses[keyof PermitSessionStopResponses];

export type PermitSessionStartData = {
  body: PermitSessionData;
  path: {
    grant_id: string;
  };
  query?: never;
  url: "/permits/grant/{grant_id}/session";
};

export type PermitSessionStartErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PermitSessionStartResponses = {
  200: PermitSession;
};

export type PermitSessionStartResponse =
  PermitSessionStartResponses[keyof PermitSessionStartResponses];

export type PermitListSessionsData = {
  body: SearchPermitSessions;
  path?: never;
  query?: never;
  url: "/permits/session/search";
};

export type PermitListSessionsErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PermitListSessionsResponses = {
  200: PaginatedForPermitSession;
};

export type PermitListSessionsResponse =
  PermitListSessionsResponses[keyof PermitListSessionsResponses];

export type SearchSpotClassesData = {
  body: SearchSpotClasses;
  path?: never;
  query?: never;
  url: "/spot_classes/search";
};

export type SearchSpotClassesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchSpotClassesResponses = {
  200: Array<SpotClass>;
};

export type SearchSpotClassesResponse =
  SearchSpotClassesResponses[keyof SearchSpotClassesResponses];

export type SpotclassGetSpotsData = {
  body: SpotClassSpotSearch;
  path?: never;
  query?: never;
  url: "/spot_classes/spots";
};

export type SpotclassGetSpotsResponses = {
  200: Array<Spot>;
};

export type SpotclassGetSpotsResponse =
  SpotclassGetSpotsResponses[keyof SpotclassGetSpotsResponses];

export type SearchAccessCodeSeriesData = {
  body: SearchAccessCodeSeries;
  path?: never;
  query?: never;
  url: "/access_code_series/search";
};

export type SearchAccessCodeSeriesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchAccessCodeSeriesResponses = {
  200: PaginatedForAccessCodeSeries;
};

export type SearchAccessCodeSeriesResponse =
  SearchAccessCodeSeriesResponses[keyof SearchAccessCodeSeriesResponses];

export type CreateAccessCodeSeriesData = {
  body: CreateAccessCodeSeries;
  path?: never;
  query?: never;
  url: "/access_code_series";
};

export type CreateAccessCodeSeriesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type CreateAccessCodeSeriesResponses = {
  200: AccessCodeSeries;
};

export type CreateAccessCodeSeriesResponse =
  CreateAccessCodeSeriesResponses[keyof CreateAccessCodeSeriesResponses];

export type DeleteAccessCodeSeriesData = {
  body?: never;
  path: {
    /**
     * AccessCodeSeries id
     */
    id: string;
  };
  query?: never;
  url: "/access_code_series/{id}";
};

export type DeleteAccessCodeSeriesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type DeleteAccessCodeSeriesResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type GetAccessCodeSeriesData = {
  body?: never;
  path: {
    /**
     * AccessCodeSeries id
     */
    id: string;
  };
  query?: never;
  url: "/access_code_series/{id}";
};

export type GetAccessCodeSeriesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type GetAccessCodeSeriesResponses = {
  200: AccessCodeSeries;
};

export type GetAccessCodeSeriesResponse =
  GetAccessCodeSeriesResponses[keyof GetAccessCodeSeriesResponses];

export type PostAccessCodeSeriesConnectedSeriesData = {
  body: AccessCodeSeriesIds;
  path: {
    /**
     * AccessCodeSeries id
     */
    id: string;
  };
  query?: never;
  url: "/access_code_series/{id}";
};

export type PostAccessCodeSeriesConnectedSeriesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type PostAccessCodeSeriesConnectedSeriesResponses = {
  200: ConnectAccessCodeSeriesOutcome;
};

export type PostAccessCodeSeriesConnectedSeriesResponse =
  PostAccessCodeSeriesConnectedSeriesResponses[
    keyof PostAccessCodeSeriesConnectedSeriesResponses
  ];

export type UpdateAccessCodeSeriesData = {
  body: AccessCodeSeriesData;
  path: {
    /**
     * AccessCodeSeries id
     */
    id: string;
  };
  query?: never;
  url: "/access_code_series/{id}";
};

export type UpdateAccessCodeSeriesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type UpdateAccessCodeSeriesResponses = {
  200: AccessCodeSeries;
};

export type UpdateAccessCodeSeriesResponse =
  UpdateAccessCodeSeriesResponses[keyof UpdateAccessCodeSeriesResponses];

export type AccessCodeSeriesSetSitesData = {
  body: SiteIds;
  path: {
    /**
     * AccessCodeSeries id
     */
    id: string;
  };
  query?: never;
  url: "/access_code_series/{id}/sites";
};

export type AccessCodeSeriesSetSitesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type AccessCodeSeriesSetSitesResponses = {
  200: AccessCodeSeries;
};

export type AccessCodeSeriesSetSitesResponse =
  AccessCodeSeriesSetSitesResponses[keyof AccessCodeSeriesSetSitesResponses];

export type SearchAccessCodesData = {
  body: AccessCodesSearch;
  path?: never;
  query?: never;
  url: "/access_codes/search";
};

export type SearchAccessCodesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type SearchAccessCodesResponses = {
  200: PaginatedForAccessCode;
};

export type SearchAccessCodesResponse =
  SearchAccessCodesResponses[keyof SearchAccessCodesResponses];

export type BulkCreateAccessCodesData = {
  body: AccessCodesBulkCreate;
  path?: never;
  query?: never;
  url: "/access_codes/create";
};

export type BulkCreateAccessCodesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type BulkCreateAccessCodesResponses = {
  200: Array<AccessCode>;
};

export type BulkCreateAccessCodesResponse =
  BulkCreateAccessCodesResponses[keyof BulkCreateAccessCodesResponses];

export type BulkUpdateAccessCodesData = {
  body: AccessCodesBulkUpdate;
  path?: never;
  query?: never;
  url: "/access_codes/update";
};

export type BulkUpdateAccessCodesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type BulkUpdateAccessCodesResponses = {
  200: Array<AccessCode>;
};

export type BulkUpdateAccessCodesResponse =
  BulkUpdateAccessCodesResponses[keyof BulkUpdateAccessCodesResponses];

export type BulkDeleteAccessCodesData = {
  body: AccessCodeIds;
  path?: never;
  query?: never;
  url: "/access_codes/delete";
};

export type BulkDeleteAccessCodesErrors = {
  /**
   * Login required
   */
  401: unknown;
  /**
   * User does not have access to the requested resource
   */
  403: unknown;
};

export type BulkDeleteAccessCodesResponses = {
  /**
   * no content
   */
  200: unknown;
};

export type GetCounterData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/counter";
};

export type GetCounterResponses = {
  200: CounterState;
};

export type GetCounterResponse = GetCounterResponses[keyof GetCounterResponses];

export type ClientOptions = {
  baseUrl:
    | "https://parkito.parkando.cloud/api"
    | "http://localhost:3000/api"
    | (string & {});
};
